import {globalUser} from "./globals.js";
import {
    addCompanyCompanyAlerts,
    addCompanyCompanyLogs,
    addCompanyMessages, addCompanyNewsItems, getCompanyChampionships, getCompanyEvents,
    getCompanyFeudItems, getCompanyGimmickMatches,
    getCompanyPowerups, getCompanySegmentItems,
    getCompanyStaff, getCompanyTournaments, removeCompanyChampionships
} from "../models/company.js";
import {
    addMatchChampionshipReigns, addMatchChampionships,
    addMatchParticipants, getAllSuperstarsForMatch,
    getMatchChampionships,
    getMatchFeuds,
    getMatchGimmickMatch,
    getMatchParticipants,
    getMatchTournament, Match
} from "../models/match.js";
import {addRosterFeuds, getRosterSuperstars, getRosterTagTeams} from "../models/roster.js";
import {
    changeProperty,
    createCompanyAlert,
    getCompanyParentEvents,
    getHighestLevelStaffMemberByRole,
    getRandomStaffMemberByRole,
    getStaffAgeMultiplier,
    processChampionshipXpChange,
    updateStaffMemberXp,
    checkObjectHot,
    checkObjectStale,
    getTournamentDisplayData,
    getChampionshipPopularityIncrease,
    getChampionshipPopularityDecrease,
    processObjectiveCompleted
} from "./companies.js";
import {matchFinishesData} from "../data/matchFinishes.js";
import {
    getEventMatchesAndSegments, getEventMatchesData, getEventSegmentsData,
    getParentEventForEvent,
    getStreakData
} from "./events.js";
import {
    Superstars,
    TagTeams,
    Championships,
    Matches,
    ChampionshipReigns,
    Streaks,
    Factions,
    CompanyLogs,
    Feuds
} from "../models/models.js";
import {
    checkAcquireTrait,
    getKayfabePointsChange,
    getRosterMemberSuperstars,
    getSuperstarManagerUsedForMatchOrSegment,
    getTraitWeightsForSuperstars,
    updateSuperstarKayfabePoints,
    debutGimmick,
    evaluateInjury,
    getSuperstarChampionshipsToVacate,
    checkSuperstarGraphicMask,
    getRankFromPopularity,
    checkForSuperstarInjury,
    addInjuryToSuperstar,
    checkSuperstarWorkThroughInjury,
    addKayfabeInjuryToSuperstar,
    addNextGimmickBoost,
    getGraphicForSuperstar,
    removeSuperstarGraphicHair,
    removeSuperstarGraphicMask,
    updateSuperstarMorale,
    getSuperstarWorkrate,
    getSuperstarLastName,
    checkSuperstarSegmentAvailability,
    checkSuperstarBrandAvailability,
    getSuperstarChampionshipsFromCompanyChampionships,
    removeSuperstarsFromManager,
    addSuperstarsToManager,
    updateSuperstarFatigue,
    getSuperstarFatigueChangeForMatch,
    updateSuperstarPopularity,
    addSuperstarGraphicHair,
    getSuperstarMoraleChange,
    vacateChampionships,
    getGimmickEffectivenessEffect
} from "./superstars.js";
import {
    addEventMatches,
    addEventStreaks,
    addEventTournaments,
    getEventStreaks,
    removeEventStreaks
} from "../models/event.js";
import {getStreakTalent, Streak} from "../models/streak.js";
import {CompanyLog} from "../models/companyLog.js";
import {
    checkAreObjArraysEqual,
    commaSeparate,
    getRandomChoice,
    getRandomInt,
    getRosterMemberRank,
    getTalentCompany,
    limitValueBetweenRange,
    objectInArray,
    weightedChoice,
    myround,
    getArrayMaxByProperty,
    range,
    shuffle,
    getRosterMemberPopularity,
    getUniqueObjects,
    getOvernessText,
    getMoraleText,
    getTalentAgeMultiplier,
    captureError,
    getRandomUniform, eventPrestigeXps
} from "./helpers.js";
import {
    getFeudRating,
    getMatchesForStaleFeud,
    getRosterMemberFeuds,
    getFeudCreationBoosts,
    getParticipantFeuds, checkFeudBlowoffMatchParticipantType, runFeudConsequence
} from "./feuds.js";
import {
    addFeudFactions,
    addFeudSuperstars,
    addFeudTagTeams,
    Feud, getFeudFeudItem,
    getFeudMatches,
    getFeudParticipants
} from "../models/feud.js";
import {addFeudItemFeuds} from "../models/feudItem.js";
import {
    addSuperstarChampionshipReigns,
    addSuperstarChampionships,
    addSuperstarStreaks,
    addSuperstarWonTournaments,
    getSuperstarChampionships,
    getSuperstarCurrentGimmick,
    getSuperstarFactions,
    getSuperstarTagTeams,
    removeSuperstarChampionships
} from "../models/superstar.js";
import {
    addTagTeamStreaks, addTagTeamSuperstars,
    addTagTeamWonTournaments,
    getTagTeamSuperstars, removeSuperstarFromTagTeam
} from "../models/tagTeam.js";
import {traitsData} from "../data/traits.js";
import {
    createLastAppearanceMessage,
    createNoAppearancesMessage,
    createPowerupMessage,
    createPresidentFotcSuperstarMessage,
    createAggravatedInjurySuperstarMessage,
    createWorkThroughInjurySuperstarMessage,
    createInjuryMessage,
    createGimmickChangeBoostMessage,
    createSpecialSegmentUnlockedMessage,
    createSuperstarLevelUpMessage,
    createPresidentOverSuperstarMessage, createPresidentChampionInjuryMessage
} from "./messages.js";
import {
    generateGimmickMatchText,
    getMatchData,
    getMatchRefereeSuperstar,
    getTournamentFinalBonus,
    selectRandomOpponent
} from "./matches.js";
import {graphicsData} from "../data/graphics.js";
import {
    addChampionshipChampionshipReigns,
    getChampionshipCurrentReign,
    getChampionshipMatchContract,
    getChampionshipSuperstar
} from "../models/championship.js";
import {
    checkAreChampionshipsEqual, checkChampionshipSegmentItemsToUnlock,
    compareChampionships,
    getChampionshipMatchData,
    getChampionshipXpChange
} from "./championships.js";
import {ChampionshipReign} from "../models/championshipReign.js";
import {setManagersForMatchOrSegment} from "./managers.js";
import {checkTalentRequestAction} from "./talentRequests.js";
import {getTournamentEvent, getTournamentMatchContracts, getTournamentMatches} from "../models/tournament.js";
import {getGameActiveCompanies} from "./games.js";
import {getNextRoundMatches, getAdvancingParticipants, addWinnerToNextRound} from "./tournaments.js";
import {getChampionshipsDisplayName} from "../ui/ui-helpers.js";
import {gimmickMatchUnlocksData} from "../data/gimmickMatchUnlocks.js";
import {getFactionSuperstars} from "../models/faction.js";
import {charactersData} from "../data/characters.js";
import {turnRosterMember} from "./rosters.js";
import {generateNewsItem} from "./news.js";
import {
    processFactionXpChangeForFaction,
    processFactionXpChangeForSuperstar
} from "./factions.js";
import {addTalentMatchContracts} from "../models/matchContract.js";
import {
    addAnnualTournamentInjuredParticipantId,
    addAnnualTournamentInjuryReplacement,
    getAnnualTournamentCpuReplacement,
    getAnnualTournamentDialogData,
    getAnnualTournamentParticipantOrganization, getAnnualTournamentWinnerSegmentData
} from "./annualTournament.js";
import {awardPowerup, getPowerupsToUnlock} from "./powerups.js";
import {loadUser, saveUser} from "./user.js";
import {processPowStarResult} from "./passionOfWrestling.js";

async function processPlayMatch(match, winnerName, event, company, mainCompany, mainRoster, indieRoster,
                                game, cashinData, matchFinishData, graphics, rosterSuperstars = null,
                                companyParentEvents = null, companyChampionships = null, staffMembers = null,
                                segmentsAndMatches = null, effect = null, simulator = false) {  // process_match_result
    try {
        let data = {};
        const matchFeuds = await getMatchFeuds(match);
        const tournament = await getMatchTournament(match);
        const rosterTagTeams = await getRosterTagTeams(mainRoster);
        if (!companyParentEvents) {
            companyParentEvents = await getCompanyParentEvents(company);
        }
        if (!staffMembers) {
            staffMembers = await getCompanyStaff(company);
        }
        if (!companyChampionships) {
            companyChampionships = await getCompanyChampionships(company);
        }
        if (!rosterSuperstars) {
            rosterSuperstars = await getRosterSuperstars(mainRoster);
        }
        if (!segmentsAndMatches) {
            segmentsAndMatches = await getEventMatchesAndSegments(event);
        }
        const month = game.monthCount;
        const year = game.year;
        const realYear = company.realYear;
        let newMatch;
        let type = match.type;

        // Get match finish
        let matchFinish = matchFinishesData.find(x => x.name === matchFinishData['name']);

        // Check if weekly show
        const weeklyShow = event.weeklyShow || event.name === 'Weekly Show';

        // Check if main event
        segmentsAndMatches.sort((a, b) => a.order - b.order);
        const mainEvent = match.$loki === segmentsAndMatches[0].$loki && match.objectName === segmentsAndMatches[0].objectName;

        // Check for tournament
        let annualTournament = tournament ? tournament.annualTournament : false;
        let checkTournament = true;
        if (tournament) {
            checkTournament = match.tournamentRound && match.tournamentRound === tournament.rounds;
        }
        if (annualTournament) {
            staffMembers = [];
        }

        // Declare arrays
        let overnessChanges = [], staffSkillIncreases = [], gimmickEffectivenessLevelChanges = [], hairRemoved = [],
            hairAdded = [], maskRemoved = [], unavailable = [], vacated = [], streaks = [], feudPotentials = [],
            feudHypeIncreased = [], feudsStarted = [], turnedHeel = [], turnedFace = [], debutedGimmicks = [],
            hotFeuds = [],
            championshipPrestiges = [], unlockedChampionshipSegmentItems = [], bloodySuperstarsData = [],
            factionConsequences = [],
            factionReputationsData = [], managersRemoved = [], managersAdded = [], fotcChanges = [];

        // Declare variables
        let updateGraphics = false;
        let generatedText = null;
        let holyShitData = null;
        let holyShitMomentTo = null;
        let newTournamentRound = false;
        let interferingMember;
        let unlockedGimmickMatches = [];
        let gimmickMatchLevelData = null;

        // Add finish name and finish text to match
        if (matchFinish) {
            match.finishName = matchFinish['name'];

            // Get interfering member for match finish, if present
            if (matchFinishData && matchFinishData['interferingMemberUid']) {
                if (matchFinishData['interferingMemberType'] === 'superstar') {
                    interferingMember = await Superstars.get(matchFinishData['interferingMemberUid'])
                } else if (matchFinishData['interferingMemberType'] === 'team') {
                    interferingMember = await TagTeams.get(matchFinishData['interferingMemberUid'])
                } else if (matchFinishData['interferingMemberType'] === 'faction') {
                    interferingMember = await Factions.get(matchFinishData['interferingMemberUid'])
                }
                if (interferingMember) {
                    match.finishText = interferingMember.name;
                }
            }
        }

        // Get attributes of match finish (don't affect record for annual tournament)
        let affectRecord = (!matchFinish || matchFinish['affectRecord']) && !annualTournament;
        let changeChampionship = !matchFinish || matchFinish['changeChampionship'];

        // Get participants
        let matchParticipants = await getMatchParticipants(match);
        let matchGimmick = await getMatchGimmickMatch(match);
        if (matchGimmick && matchGimmick.consequence === 'random_opponent' && matchParticipants.length < 2) {
            // Add random opponent to match
            let allTalent;
            if (type === 'singles') {
                allTalent = await getRosterSuperstars(mainRoster)
            } else if (type === 'tag') {
                allTalent = (await getRosterTagTeams(mainRoster))
                    .filter(x => x.trio === matchParticipants[0].trio && !x.temporary)
            }
            let randomOpponentData = await selectRandomOpponent(matchParticipants[0], allTalent, event);
            let opponent = randomOpponentData[0];
            await addMatchParticipants(match, [opponent]);
            matchParticipants.push(opponent);
        }

        // Get superstars
        let matchSuperstars = [];
        for (const x of matchParticipants) {
            let s = await getRosterMemberSuperstars(x);
            x.tempSuperstars = s;
            matchSuperstars.push(...s);
        }

        // Set stating morale for matchSuperstars
        for (const x of matchSuperstars) {
            x.startingMorale = x.morale;
            x.startingOverness = x.overness;
        }

        // Get winner
        let winnerParticipant = matchParticipants.find(x => x.name === winnerName);
        let winnerSuperstars = winnerParticipant.tempSuperstars;

        // Check streaks
        let streakEnded = null;
        if (!weeklyShow && event.prestige === 'A' && affectRecord) {
            let parentEvent = await getParentEventForEvent(companyParentEvents, event);
            if (parentEvent) {
                for (const x of matchParticipants) {
                    let existingStreak;
                    for (const streak of (await getEventStreaks(parentEvent))) {
                        let streakTalent = await getStreakTalent(streak);
                        if (streakTalent.objectName === x.objectName && streakTalent.$loki === x.$loki) {
                            existingStreak = streak;
                            break;
                        }
                    }
                    if (existingStreak) {
                        let streakData = {};
                        if (x.$loki === winnerParticipant.$loki) {
                            // Add to streak if winner and not tournament match or tournament match final
                            if (checkTournament) {
                                existingStreak.length += 1;
                                if (existingStreak.length === 2) {
                                    streakData['started'] = true
                                } else if (existingStreak.length > 2) {
                                    streakData['extended'] = true
                                }

                                // Get streak data
                                streaks.push({...streakData, ...(await getStreakData(existingStreak))});
                            }
                        } else {
                            // End streak
                            if (existingStreak.length > 2) {
                                streakData['ended'] = true;
                                streakData['winner'] = winnerParticipant.name;
                                streakEnded = existingStreak;

                                // Add to company log
                                let streakTalent = await getStreakTalent(existingStreak);
                                let newLog = CompanyLog(month, realYear);
                                newLog.text = `${winnerParticipant.name} ended ${streakTalent.name}'s ${existingStreak.length} ` +
                                    `match undefeated streak at ${event.name}!`;
                                newLog.type = 'moment';
                                newLog.realYear = year;
                                newLog.eventName = event.name;
                                newLog.value = existingStreak.length * 2;
                                await CompanyLogs.insert(newLog);
                                await addCompanyCompanyLogs(company, [newLog]);

                                // Get streak data
                                streaks.push({...streakData, ...(await getStreakData(existingStreak))});

                                // Add feud
                                if (existingStreak.length > 4) {
                                    let newFeudParticipants = [streakTalent, winnerParticipant];
                                    let addFeudData = await checkToAddFeud('streak-broken', newFeudParticipants,
                                        company, mainRoster, month, year);
                                    if (addFeudData['key'] === 'feudPotentials') {
                                        feudPotentials.push(addFeudData['value'])
                                    } else if (addFeudData['key'] === 'feudHypeIncreased') {
                                        feudHypeIncreased.push(addFeudData['value'])
                                    }
                                }
                            }

                            await removeEventStreaks(parentEvent, [existingStreak]);
                            existingStreak.ended = true;
                        }
                    } else {
                        // Create new streak if winner
                        if (x.$loki === winnerParticipant.$loki && checkTournament) {
                            let newStreak = Streak();
                            await Streaks.insert(newStreak);
                            if (x.objectName === 'superstar') {
                                await addSuperstarStreaks(x, [newStreak])
                            } else if (x.objectName === 'tagTeam') {
                                await addTagTeamStreaks(x, [newStreak])
                            }
                            await addEventStreaks(parentEvent, [newStreak]);
                        }
                    }
                }
            }
        }

        // Check for tournament final
        let tournamentFinal = null;
        let lowerPopularityChange = false;
        if (tournament) {
            if (match.tournamentRound === tournament.rounds && !tournament.annualTournament) {
                tournamentFinal = tournament;
                match.tournamentFinalBonus = getTournamentFinalBonus(tournament);
            } else if (tournament.type === 'round-robin' && tournament.stage !== 'elimination') {
                lowerPopularityChange = true;
            }
        }

        // Get losers
        let loserParticipants = matchParticipants.filter(x => x.$loki !== winnerParticipant.$loki);

        // Check for holy shit moment
        if (matchGimmick) {
            let pick = getRandomInt(0, 100);
            let holyShitMomentChance = 25;

            // Get superstar who performs holy shit moment
            let superstarsTraitsWeights = getTraitWeightsForSuperstars(winnerSuperstars,
                'holy_shit_moment_chance_multiplier');
            let holyShitMomentBy = weightedChoice(superstarsTraitsWeights);

            // Get trait multiplier for winner superstar
            let holyShitMomentChanceMultiplier = 1;
            for (const trait of holyShitMomentBy.traits) {
                let traitData = traitsData[trait];
                if (traitData && traitData['holy_shit_moment_chance_multiplier']) {
                    holyShitMomentChanceMultiplier *= traitData['holy_shit_moment_chance_multiplier']
                }
            }
            holyShitMomentChanceMultiplier = limitValueBetweenRange(holyShitMomentChanceMultiplier, 0, 2.4);
            holyShitMomentChance *= holyShitMomentChanceMultiplier;

            if (pick <= holyShitMomentChance) {
                let pointsToAdd = 30;
                let overnessIncrease = getRandomInt(1, 3);

                // Get superstar to perform holy shit moment on
                let randomLoserParticipant = getRandomChoice(loserParticipants);
                holyShitMomentTo = getRandomChoice(randomLoserParticipant.tempSuperstars);

                // Get holy shit text and data
                let holyShitText = generateGimmickMatchText(matchGimmick, holyShitMomentBy, holyShitMomentTo);
                holyShitData = {
                    'text': holyShitText, 'overnessIncrease': overnessIncrease,
                    'superstarName': holyShitMomentBy.name, 'pointsGained': pointsToAdd
                };

                // Boost overness
                holyShitMomentBy.overness += overnessIncrease;

                // Add points
                company.points += pointsToAdd;

                // Change objective property
                if (company.userControlled) {
                    let objectiveCompleted = await changeProperty({
                        name: 'holy shit moments',
                        change: 1,
                        company: company
                    });
                    if (objectiveCompleted) {
                        await processObjectiveCompleted(objectiveCompleted, company);
                    }
                }

                // Add company log
                let newLog = CompanyLog(month, realYear);
                newLog.text = holyShitText;
                newLog.type = 'moment';
                newLog.realYear = year;
                newLog.eventName = event.name;
                newLog.value = 2;
                await CompanyLogs.insert(newLog);
                await addCompanyCompanyLogs(company, [newLog]);

                // Add kayfabe points
                let kayfabePointsChange = await getKayfabePointsChange({changeType: 'holyShitMoment'});
                updateSuperstarKayfabePoints(holyShitMomentBy, kayfabePointsChange);

                // Award or unlock powerup
                if (company.storyName !== 'mars' && getRandomInt(0, 100) <= 25 && company.style === 'entertainment' &&
                    company.introducedPowerups) {
                    let powerups = await getCompanyPowerups(company);
                    if (powerups.length > 0) {
                        if (matchGimmick.level < 3) {
                            // Award powerup
                            if (getRandomInt(0, 100) <= 50) {
                                await awardOrUnlockPowerup(powerups)
                            }
                        } else {
                            let powerupsToUnlock = getPowerupsToUnlock(powerups);
                            // Unlock powerup
                            if (powerupsToUnlock.length > 0) {
                                await awardOrUnlockPowerup(powerupsToUnlock, true);
                            }
                            // Award an unlocked powerup if all unlocked
                            else {
                                await awardOrUnlockPowerup(powerups)
                            }
                        }
                    }
                }
            }
        }

        // Check for blood boost
        let bloodBoost = 0;
        let bloodySuperstars = [];
        let randomLoserParticipant = getRandomChoice(loserParticipants);
        let randomLoserSuperstar = getRandomChoice(randomLoserParticipant.tempSuperstars);

        // Add blood for specific special match finishes
        if (matchFinish && ['Pass Out', 'Respectful End', 'By Any Means', 'Throw In Towel'].includes(matchFinish['name'])) {
            bloodySuperstars.push(randomLoserSuperstar)
        } else if (matchGimmick) {
            // Add blood in first blood match
            if (matchGimmick.name.toLowerCase() === 'first blood') {
                bloodySuperstars.push(randomLoserSuperstar);
            }
            // Chance to add blood in other gimmick matches
            else {
                let bleederTraitSuperstar = null;
                let dangerousWorkerTraitSuperstar = null;
                let addBloodChance = 2;
                if (holyShitData) {
                    addBloodChance += 30;
                } else {
                    // Get trait to add blood chance
                    let addBloodChanceBoost = 0;
                    for (const matchSuperstar of matchSuperstars) {
                        for (const trait of matchSuperstar.traits) {
                            let traitData = traitsData[trait];
                            if (traitData && traitData['add_blood_chance_boost']) {
                                addBloodChanceBoost += traitData['add_blood_chance_boost'];
                                bleederTraitSuperstar = matchSuperstar;
                            }
                            if (traitData && traitData['add_blood_to_opponent_chance_boost']) {
                                addBloodChanceBoost += traitData['add_blood_to_opponent_chance_boost'];
                                dangerousWorkerTraitSuperstar = matchSuperstar;
                            }
                        }
                    }
                    addBloodChanceBoost = limitValueBetweenRange(addBloodChanceBoost, 0, 40);
                    addBloodChance += addBloodChanceBoost;
                }

                if (getRandomInt(0, 100) <= addBloodChance) {
                    // Choose bloody superstar
                    let bloodySuperstar;
                    if (holyShitData) {
                        bloodySuperstar = holyShitMomentTo;
                    } else {
                        if (bleederTraitSuperstar) {
                            // Add blood to superstar with bleeder trait
                            bloodySuperstar = bleederTraitSuperstar
                        } else if (dangerousWorkerTraitSuperstar) {
                            // Get superstar from opponents of dangerous worker
                            let dangerousWorkerTraitParticipant;
                            for (const y of matchParticipants) {
                                if (objectInArray(dangerousWorkerTraitSuperstar, y.tempSuperstars)) {
                                    dangerousWorkerTraitParticipant = y;
                                    break;
                                }
                            }
                            const dangerousWorkerTraitParticipantSuperstars = dangerousWorkerTraitParticipant.tempSuperstars;
                            bloodySuperstar = getRandomChoice(matchSuperstars.filter(y =>
                                !objectInArray(y, dangerousWorkerTraitParticipantSuperstars)));
                        } else {
                            // Otherwise get random superstar
                            bloodySuperstar = getRandomChoice(matchSuperstars);
                        }
                    }
                    bloodySuperstars.push(bloodySuperstar);
                    bloodBoost += 0.25;

                    // Check to acquire trait
                    await checkAcquireTrait(bloodySuperstar, 'Bleeder');

                    // Chance to add second bloody superstar
                    if (getRandomInt(0, 100) <= 10) {
                        let superstarsWithoutBlood = matchSuperstars.filter(x => !objectInArray(x, bloodySuperstars));
                        bloodySuperstars.push(getRandomChoice(superstarsWithoutBlood));
                        bloodBoost += 0.25;
                    }
                }
            }
        }

        // Add blood to superstars
        if (bloodySuperstars.length > 0) {
            let bloodObjects = graphicsData['bloodObjects'];
            for (const bloodySuperstar of bloodySuperstars) {
                bloodySuperstarsData.push({'name': bloodySuperstar.name});
                // Find superstar graphic, add blood object
                if (graphics) {
                    let participantGraphic = graphics.find(y => y && y['uid'] === bloodySuperstar.$loki);
                    if (participantGraphic) {
                        let bloodObject = getRandomChoice(bloodObjects);
                        participantGraphic['blood'] = {'object': bloodObject['number'], 'colors': ['0xFFFFFF']};

                        // Add temporary injury
                        bloodySuperstar.temporaryInjury = bloodObject['type'];
                    }
                }
            }

            // Don't add graphics when simulating (match_graphics is None there)
            if (graphics) {
                updateGraphics = true;
            }
        }

        // Get managers present in match
        let matchManagers = [];
        let fullTimeManagerFinish = false;
        for (const s of matchSuperstars) {
            let superstarManager = await getSuperstarManagerUsedForMatchOrSegment(s, match.managersUsed, rosterSuperstars);
            if (superstarManager && !objectInArray(superstarManager, matchManagers)) {
                matchManagers.push(superstarManager);
                // Check if full-time manager present and they are part of finish
                if (matchFinish && superstarManager.fullTimeManager) {
                    if (!interferingMember || interferingMember.$loki === superstarManager.$loki) {
                        fullTimeManagerFinish = true;
                    }
                }
            }
        }

        // Get match rating
        let matchChampionships = await getMatchChampionships(match);
        let ratingData = await getMatchRating(matchParticipants, matchSuperstars, matchChampionships, matchGimmick, match, weeklyShow, effect,
            matchFinish, matchFeuds, bloodBoost, fullTimeManagerFinish, annualTournament, company.storyName,
            segmentsAndMatches);

        // Get and set match's rating
        let rating = ratingData['rating'];
        if (cashinData['cashin']) {
            rating = null
        }
        if (rating !== null) {
            if (event.activeEffect === 'lower_match_ratings') {
                rating -= getRandomChoice([0.5, 0.75, 1, 1.5, 1.5, 2, 2.5]);
                if (rating < 0) {
                    rating = 0
                }
            } else if (event.activeEffect === 'raise_match_ratings') {
                rating += getRandomChoice([0.75, 1, 1.5, 1.5]);
                if (rating > 6) {
                    rating = 6
                }
            }
        }
        match.rating = rating;

        // Check for hot match
        let hotMatch = await checkMatchHot(match, matchParticipants, matchSuperstars);

        // Process popularity changes
        let [winnerData, losersData] = await processMatchWinnerAndLosers(winnerParticipant, loserParticipants,
            matchChampionships, matchGimmick, company, match, streakEnded, tournamentFinal, lowerPopularityChange,
            weeklyShow, hotMatch, matchFinish, rosterSuperstars);

        // Set winner and loser
        match.winner = winnerParticipant.name;
        match.loser = commaSeparate(loserParticipants.map(y => y.name));

        // Add won/defended/retained championships to match
        if (winnerData['wonChampionships'].length > 0) {
            match.championshipsWon = getChampionshipsDisplayName(winnerData['wonChampionships'])
        }
        if (winnerData['defendedChampionships'].length > 0) {
            match.championshipsDefended = getChampionshipsDisplayName(winnerData['defendedChampionships'])
        }
        if (winnerData['retainedChampionships'].length > 0) {
            match.championshipsRetained = getChampionshipsDisplayName(winnerData['retainedChampionships'])
        }

        // Check championship contract win objective
        for (const y of matchChampionships) {
            if (y.championshipContract) {
                let holder = await getChampionshipSuperstar(y);
                if (holder && company.userControlled) {
                    // Change objective property
                    let objectiveCompleted = await changeProperty({
                        name: 'win championship contract', change: 1,
                        company: company, superstarName: holder.name
                    });
                    if (objectiveCompleted) {
                        await processObjectiveCompleted(objectiveCompleted, company);
                    }
                }
            }
        }

        // Check for holy shit moment in pure company, added later because it depends on match rating
        if (!matchGimmick && (company.style === 'pure' || annualTournament) && rating > 4) {
            let pick;
            if (rating >= 4.75) {
                pick = getRandomInt(0, 60)
            } else {
                pick = getRandomInt(0, 100)
            }
            let holyShitMomentChance = 20;

            // Get superstar who performs holy shit moment
            const superstarsTraitsWeights = getTraitWeightsForSuperstars(winnerSuperstars,
                'holy_shit_moment_pure_chance_multiplier');
            let holyShitMomentBy = weightedChoice(superstarsTraitsWeights);

            // Get trait multiplier for holy shit moment by
            for (const trait of holyShitMomentBy.traits) {
                const traitData = traitsData[trait];
                if (traitData && traitData['holy_shit_moment_pure_chance_multiplier']) {
                    holyShitMomentChance *= traitData['holy_shit_moment_pure_chance_multiplier'];
                }
            }

            if (pick <= holyShitMomentChance) {
                const pointsToAdd = !annualTournament ? 30 : 0;
                let overnessIncrease = getRandomInt(1, 3);

                // Get superstar to perform holy shit moment on
                let randomLoserParticipant = getRandomChoice(loserParticipants);
                holyShitMomentTo = getRandomChoice(randomLoserParticipant.tempSuperstars);

                // Get holy shit text and data
                let holyShitText = generateGimmickMatchText(null, holyShitMomentBy, holyShitMomentTo);
                holyShitData = {
                    'text': holyShitText, 'overnessIncrease': overnessIncrease,
                    'superstarName': holyShitMomentBy.name, 'pointsGained': pointsToAdd
                };

                // Boost overness
                holyShitMomentBy.overness += overnessIncrease;

                // Add points
                company.points += pointsToAdd;

                // Add kayfabe points
                let kayfabePointsChange = await getKayfabePointsChange({changeType: 'holyShitMoment'});
                updateSuperstarKayfabePoints(holyShitMomentBy, kayfabePointsChange);

                if (!annualTournament) {
                    // Change objective property
                    if (company.userControlled) {
                        let objectiveCompleted = await changeProperty({
                            name: 'holy shit moments',
                            change: 1,
                            company: company
                        });
                        if (objectiveCompleted) {
                            await processObjectiveCompleted(objectiveCompleted, company);
                        }
                    }

                    // Add company log
                    let newLog = CompanyLog(month, realYear);
                    newLog.text = holyShitText;
                    newLog.type = 'moment';
                    newLog.realYear = year;
                    newLog.eventName = event.name;
                    newLog.value = Math.round(rating);
                    await CompanyLogs.insert(newLog);
                    await addCompanyCompanyLogs(company, [newLog]);

                    // Award or unlock powerup
                    if (getRandomInt(0, 100) <= 25 && company.introducedPowerups) {
                        let powerups = await getCompanyPowerups(company);
                        if (powerups.length > 0) {
                            if (rating < 5) {
                                // Award powerup
                                if (getRandomInt(0, 100) <= 50) {
                                    await awardOrUnlockPowerup(powerups)
                                }
                            } else {
                                let powerupsToUnlock = getPowerupsToUnlock(powerups);
                                // Unlock powerup
                                if (powerupsToUnlock.length > 0) {
                                    await awardOrUnlockPowerup(powerupsToUnlock, true);
                                }
                                // Award an unlocked powerup if all unlocked
                                else {
                                    await awardOrUnlockPowerup(powerups)
                                }
                            }
                        }
                    }
                }
            }
        }

        // Process match superstars
        for (const s of matchSuperstars) {
            let talentCompany = await getTalentCompany(s);

            // Check fotc
            if (!weeklyShow) {
                if (!s.faceOfTheCompany) {
                    if (s.popularity >= 1000) {
                        s.faceOfTheCompanyCounter += 1;
                        if (s.faceOfTheCompanyCounter >= 6) {
                            s.faceOfTheCompany = true;
                            fotcChanges.push({'name': s.name, 'faceOfTheCompany': s.faceOfTheCompany});

                            // Change objective property
                            let objectiveCompleted = await changeProperty({
                                name: 'face of the company', change: 1,
                                company: company, superstarName: s.name
                            });
                            if (objectiveCompleted) {
                                await processObjectiveCompleted(objectiveCompleted, company);
                            }

                            // Update faction rep
                            let superstarFactionsData = await processFactionXpChangeForSuperstar({
                                superstar: s,
                                fotcChange: 'becameFotc'
                            });
                            factionReputationsData.push(...superstarFactionsData);

                            // Add kayfabe points
                            let kayfabePointsChange = await getKayfabePointsChange({changeType: 'fotc'});
                            updateSuperstarKayfabePoints(s, kayfabePointsChange);

                            // Add TGI president's message
                            if (talentCompany && talentCompany.userControlled && getRandomInt(0, 100) <= 40) {
                                let annualTournamentHeld = (await getCompanyTournaments(mainCompany))
                                    .find(y => y.annualTournament && y.status === 'ended');
                                if (annualTournamentHeld) {
                                    let newMessage = await createPresidentFotcSuperstarMessage(s, game, month, year);
                                    await addCompanyMessages(talentCompany, [newMessage]);
                                }
                            }
                        } else if (s.faceOfTheCompanyCounter === 1) {
                            fotcChanges.push({
                                'name': s.name, 'faceOfTheCompany': s.faceOfTheCompany,
                                'faceOfTheCompanyStart': true
                            });
                        }
                    }
                    // Reset fotc counter
                    else {
                        s.faceOfTheCompanyCounter = 0;
                    }
                }
                // Remove fotc
                else if (s.popularity < 1000) {
                    s.faceOfTheCompany = false;
                    s.faceOfTheCompanyCounter = 0;
                    fotcChanges.push({'name': s.name, 'faceOfTheCompany': s.faceOfTheCompany});

                    // Update faction rep
                    let superstarFactionsData = await processFactionXpChangeForSuperstar({
                        superstar: s,
                        fotcChange: 'lostFotc'
                    });
                    factionReputationsData.push(...superstarFactionsData);
                }
            }

            // Reduce appearance for part timers
            if (s.partTimer && s.activeEffect !== 'traded') {
                if (!match.tournamentRound || match.tournamentRound === 1) {
                    s.appearances -= 1;
                    if (s.appearances < 0) {
                        s.appearances = 0;
                    }
                }
            }

            // Reset active effect
            if (s.activeEffect) {
                if (s.activeEffect === 'retirement_return') {
                    s.activeEffect = null;
                    s.retired = true;
                    s.partTimer = false;
                    s.appearances = null;
                } else if (s.activeEffect === 'one_match_appearance') {
                    s.activeEffect = null;
                }
            }

            // Check if last/no appearances, send message
            if (talentCompany && talentCompany.userControlled) {
                if (s.partTimer && (!match.tournamentRound || match.tournamentRound === 1)) {
                    const talentManager = getRandomStaffMemberByRole(staffMembers, 'talent_manager');
                    if (s.appearances <= 0) {
                        let newMessage = await createNoAppearancesMessage(s, month, year, talentManager);
                        await addCompanyMessages(company, [newMessage]);
                    } else if (s.appearances === 1) {
                        let newMessage = await createLastAppearanceMessage(s, month, year, talentManager);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }
            }

            // Debut new gimmick if set
            if (s.debutNewGimmick) {
                let producer = getRandomStaffMemberByRole(staffMembers, 'producer');
                let debutedGimmickData = await debutGimmick(s, company, producer, month, year);
                debutedGimmicks.push(debutedGimmickData);
                // Add producer skill increase data
                if (debutedGimmickData['staffSkillIncreases']) {
                    staffSkillIncreases.push(debutedGimmickData['staffSkillIncreases'])
                }
            }
            // Update existing gimmick if found
            else {
                let matchSuperstarParticipant;
                for (const y of matchParticipants) {
                    if (objectInArray(s, y.tempSuperstars)) {
                        matchSuperstarParticipant = y;
                        break;
                    }
                }
                await updateSuperstarGimmickEffectiveness(s, matchSuperstarParticipant);
            }
        }

        // Process championships
        let championshipsWon = winnerData['wonChampionships'].map(x => x['name']);
        let championshipsDefended = winnerData['defendedChampionships'].map(x => x['name']);
        let championshipsRetained = winnerData['retainedChampionships'].map(x => x['name']);
        for (const x of matchChampionships) {
            let championshipSet = (x.tagTeam || x.trio) ?
                companyChampionships.filter(y => checkAreChampionshipsEqual(y, x)) : [x];

            // If match for championship contract, set cashin available
            if (x.championshipContract && !x.vacated) {
                if (!x.tagTeam && !x.trio) {
                    cashinData['cashinSinglesAvailable'] = true
                } else {
                    if (x.trio) {
                        cashinData['cashinTriosAvailable'] = true
                    } else {
                        cashinData['cashinTagAvailable'] = true
                    }
                }
            }

            // Set match contract to awarded
            if (changeChampionship) {
                for (const y of championshipSet) {
                    if (y.matchContract) {
                        let matchContract = await getChampionshipMatchContract(y);
                        if (matchContract && !matchContract.awarded) {
                            matchContract.awarded = true;
                            matchContract.availableForUse = false;
                        }
                    }
                }
            }

            // Process won
            if (championshipsWon.includes(x.name)) {
                for (const c of championshipSet) {
                    // End current reign
                    let currentReign = await getChampionshipCurrentReign(c);
                    if (currentReign) {
                        currentReign.endMonth = month;
                        currentReign.endYear = year;
                    }

                    // Add new reign
                    let newReign = ChampionshipReign(month, year);
                    await ChampionshipReigns.insert(newReign);
                    await addChampionshipChampionshipReigns(c, [newReign]);
                    await addSuperstarChampionshipReigns((await getChampionshipSuperstar(c)), [newReign]);
                    await addMatchChampionshipReigns(match, [newReign]);

                    // Transfer match contract
                    if (c.matchContract) {
                        let matchContract = await getChampionshipMatchContract(c);
                        if (matchContract) {
                            await addTalentMatchContracts(winnerParticipant, [matchContract]);
                        }
                    }
                }

                // Add championship win news
                if (x.rank === 'Main Eventer') {
                    let newsItem = await generateNewsItem({
                        company, month: game.newsMonth, year: game.newsYear, superstar: winnerParticipant,
                        newsType: 'won_championship', championship: x, event: event
                    });
                    await addCompanyNewsItems(mainCompany, [newsItem]);
                }

                // Check for POW goal if winning main championship
                if (type === 'singles' && company.storyName === 'passion' && x.name === 'POW') {
                    const powStarResult = await processPowStarResult(winnerParticipant, company);

                    // Lower match rating and remove hot if failure
                    if (powStarResult['failed']) {
                        if (match.rating >= 3) {
                            rating = myround(getRandomInt(100, 200), 25) / 100;
                            match.rating = rating;
                        }
                        if (match.hot) {
                            hotMatch = false;
                            match.hot = hotMatch;
                        }
                    }

                    // Increase match rating if success
                    if (powStarResult['completed']) {
                        if (match.rating < 4) {
                            rating = myround(getRandomInt(400, 450), 25) / 100;
                            match.rating = rating;
                        }
                    }

                    // Add superstar changes
                    if (powStarResult['superstarChanges']) {
                        try {
                            let powStarPopularityChange = powStarResult['superstarChanges']['popularityChange'];
                            if (powStarPopularityChange) {
                                winnerData['popularityChange'] += powStarPopularityChange;
                                winnerData['popularity'] = winnerParticipant.popularity;
                            }
                        }
                        catch (error) {
                            captureError(error)
                        }
                    }

                }
                // Make temporary tag team permanent if they became champions and aren't a trio tag team
                else if (type === 'tag') {
                    if (winnerParticipant.temporary && !winnerParticipant.trioTagTeam) {
                        // If team already exists (for team within a faction), don't make temporary team permanent
                        let existingTagTeam;
                        for (const y of (await getSuperstarTagTeams(winnerSuperstars[0]))) {
                            if (!y.temporary && checkAreObjArraysEqual((await getTagTeamSuperstars(y)), winnerSuperstars)) {
                                existingTagTeam = y;
                                break;
                            }
                        }
                        if (!existingTagTeam) {
                            winnerParticipant.temporary = false;

                            // Set as trio if 3 superstars in team
                            if (winnerSuperstars.length === 3) {
                                winnerParticipant.trio = true;
                            }
                        }
                    }
                }

            }
            // Process defended
            else if (championshipsDefended.includes(x.name)) {
                for (const c of championshipSet) {
                    // Add match to reign's defenses
                    let currentReign = await getChampionshipCurrentReign(c);
                    if (currentReign) {
                        await addMatchChampionshipReigns(match, [currentReign]);
                    }
                }
            }
            // Process retained
            else if (championshipsRetained.includes(x.name) && !x.vacated) {
                for (const c of championshipSet) {
                    // Add match to reign's defenses
                    let currentReign = await getChampionshipCurrentReign(c);
                    if (currentReign) {
                        await addMatchChampionshipReigns(match, [currentReign]);
                    }
                }
            }

            // Get xp data
            let championshipWon = championshipsWon.includes(x.name);
            let championshipDefendedOrRetained = championshipsDefended.concat(championshipsRetained).includes(x.name);
            let championshipXpData = await getChampionshipXpChange({
                championship: x,
                company,
                month,
                year,
                match,
                weeklyShow,
                championshipWon: championshipWon,
                championshipDefendedOrRetained: championshipDefendedOrRetained,
                mainEvent
            });

            // Process prestige
            if (championshipXpData['totalXpChange']) {
                let championshipPrestigeData = await processChampionshipXpChange(x, championshipXpData['totalXpChange'],
                    companyChampionships);
                if (championshipPrestigeData['xp']) {
                    championshipPrestigeData['xpDetails'] = championshipXpData;

                    // Add to data (if not already added)
                    if (!((championshipPrestiges.map(y => y['championshipName']))
                        .includes(championshipPrestigeData['championshipName']))) {
                        championshipPrestiges.push(championshipPrestigeData)
                    }

                    // Check for objective completed
                    if (championshipPrestigeData['prestigeIncrease']) {
                        if (company.userControlled) {
                            let objectiveCompleted = await changeProperty({
                                name: 'championship prestige', change: 1,
                                company: company, championship: x
                            });
                            if (objectiveCompleted) {
                                await processObjectiveCompleted(objectiveCompleted, company);
                            }
                        }
                        // If prestige increased over highest value, unlock prestige bonus segments
                        if (championshipPrestigeData['firstPrestigeIncrease']) {
                            unlockedChampionshipSegmentItems
                                .push(...(await checkChampionshipSegmentItemsToUnlock(championshipPrestigeData['prestige'],
                                    company)));
                        }
                    }
                }
            }
        }

        // Create new match between winner and championship contract holder
        if (cashinData['challengerName']) {
            let championshipToCashinOn;
            if (matchChampionships.length > 0) {
                championshipToCashinOn = [...matchChampionships].sort(compareChampionships)[0];

                // Find champion and challenger
                let champion;
                let challenger;
                if (type === 'singles') {
                    champion = await getChampionshipSuperstar(championshipToCashinOn);
                    challenger = rosterSuperstars.find(y => y.name === cashinData['challengerName']);
                } else if (type === 'tag') {
                    if (championshipToCashinOn.trio) {
                        champion = (await getSuperstarTagTeams(await getChampionshipSuperstar(championshipToCashinOn)))
                            .find(y => !y.temporary && y.trio);
                    } else {
                        champion = (await getSuperstarTagTeams(await getChampionshipSuperstar(championshipToCashinOn)))
                            .find(y => !y.temporary && !y.trio);
                    }
                    challenger = rosterTagTeams.find(y => y.name === cashinData['challengerName']);
                }
                if (champion && challenger) {
                    // Find championship contract
                    let championshipContract;
                    let challengerSuperstars = await getRosterMemberSuperstars(challenger);
                    for (const y of (await getSuperstarChampionships(challengerSuperstars[0]))) {
                        if (y.championshipContract) {
                            championshipContract = y;
                            break;
                        }
                    }

                    // Add match
                    newMatch = Match(event.matchesCount, type);
                    newMatch.order = match.order - 1;
                    await Matches.insert(newMatch);
                    await addEventMatches(event, [newMatch]);
                    await addMatchParticipants(newMatch, [champion, challenger]);
                    for (const c of companyChampionships.filter(x => checkAreChampionshipsEqual(x, championshipToCashinOn))) {
                        c.booked = true;
                    }
                    await addMatchChampionships(newMatch, [championshipToCashinOn]);
                    event.matchesCount += 1;
                    // Set decreasing order for matches/segments after this one
                    for (const y of segmentsAndMatches.reverse()) {
                        if (y.order <= newMatch.order) {
                            y.order -= 1;
                        }
                    }

                    // Get superstars
                    const newMatchSuperstars = await getAllSuperstarsForMatch(newMatch);

                    // Remove championship contracts
                    let championshipSet = (championshipContract.tagTeam || championshipContract.trio) ?
                        companyChampionships.filter(y => checkAreChampionshipsEqual(y, championshipContract)) :
                        [championshipContract];
                    for (const championship of championshipSet) {
                        await removeSuperstarChampionships((await getChampionshipSuperstar(championship)), [championship]);
                        await removeCompanyChampionships(company, [championship]);
                        await Championships.remove(championship);
                    }

                    // Add managers
                    if (globalUser.paid) {
                        setManagersForMatchOrSegment(newMatch, newMatchSuperstars, rosterSuperstars);
                    }

                    // Check for championship contracts
                    cashinData['cashinSinglesAvailable'] = false;
                    cashinData['cashinTagAvailable'] = false;
                    cashinData['cashinTriosAvailable'] = false;
                    for (const championship of (await getCompanyChampionships(company))) {
                        if (championship.championshipContract && !championship.vacated) {
                            if (!championship.tagTeam && !championship.trio) {
                                cashinData['cashinSinglesAvailable'] = true
                            } else {
                                if (championship.trio) {
                                    cashinData['cashinTriosAvailable'] = true
                                } else {
                                    cashinData['cashinTagAvailable'] = true
                                }
                            }
                        }
                    }
                    data['challenger'] = challenger.name;
                    data['championshipContract'] = championshipContract.name;

                    // Holy shit moment award
                    let pointsGained = 30;
                    company.points += pointsGained;

                    // Check goal
                    const objectiveCompleted = await changeProperty({
                        name: 'holy shit moments',
                        change: 1,
                        company: company
                    });
                    if (objectiveCompleted) {
                        await processObjectiveCompleted(objectiveCompleted, company);
                    }

                    // Add company log
                    const newCompanyLog = CompanyLog(game.monthCount, company.realYear);
                    CompanyLogs.insert(newCompanyLog);
                    const matchParticipantNames = matchParticipants.map(x => x.name).join(' vs ');
                    newCompanyLog.text = `${challenger.name} cashed in ${championshipContract.name} after ${matchParticipantNames}!`;
                    newCompanyLog.type = 'moment';
                    newCompanyLog.realYear = game.year;
                    newCompanyLog.eventName = event.name;
                    newCompanyLog.value = 6;
                    await addCompanyCompanyLogs(company, [newCompanyLog]);
                }
            }
        }

        // Check for injuries
        if (match.activeEffect !== 'virtual') {
            for (const matchParticipant of matchParticipants) {
                for (const s of matchParticipant.tempSuperstars) {
                    // Don't injure wrestlers in Olympus Mons match
                    if (matchGimmick && matchGimmick.name === 'Olympus Mons' && company.storyName === 'mars') {
                        break;
                    }

                    // Check for injury
                    let talentCompany = await getTalentCompany(s);
                    let opponentSuperstars = matchSuperstars.filter(x => !objectInArray(x, matchParticipant.tempSuperstars));
                    let injuryData = await checkForSuperstarInjury(s, matchParticipants, opponentSuperstars, matchGimmick,
                        holyShitData, tournament, talentCompany, game);

                    // Process injury
                    if (injuryData['months'] > 0) {
                        // Check if superstar was working through injury
                        let workingThroughInjury = s.workableInjury;

                        // Add injury to superstar
                        await addInjuryToSuperstar(s, injuryData['months'], injuryData['name'], injuryData['type'],
                            talentCompany);

                        // Get doctor
                        let doctor = getRandomStaffMemberByRole(staffMembers, 'doctor');
                        let maxDoctor = getHighestLevelStaffMemberByRole(staffMembers, 'doctor');

                        // Add injury message and company alert
                        if (talentCompany && talentCompany.userControlled) {

                            // Get talent company's doctor for TGI
                            if (annualTournament && !doctor) {
                                let talentCompanyStaff = getCompanyStaff(talentCompany);
                                doctor = getRandomStaffMemberByRole(talentCompanyStaff, 'doctor');
                                maxDoctor = getHighestLevelStaffMemberByRole(talentCompanyStaff, 'doctor');
                            }

                            // Talent message
                            if (checkSuperstarWorkThroughInjury(s)) {
                                // Superstar message to work through injury
                                if (injuryData['type'] === 'workable') {
                                    let newMessage = await createWorkThroughInjurySuperstarMessage(s, month, year);
                                    await addCompanyMessages(talentCompany, [newMessage]);
                                }
                                // Superstar message if decided to work through injury
                                if (workingThroughInjury) {
                                    let newMessage = await createAggravatedInjurySuperstarMessage(s, month, year);
                                    await addCompanyMessages(talentCompany, [newMessage]);
                                }
                            }

                            // Doctor message
                            let injuryTime = evaluateInjury(s, maxDoctor);
                            let newMessage = await createInjuryMessage(injuryTime, s, injuryData['type'],
                                workingThroughInjury, month, year, doctor);
                            await addCompanyMessages(talentCompany, [newMessage]);

                            // Company alert
                            let newCompanyAlert = await createCompanyAlert('injured', s.name);
                            await addCompanyCompanyAlerts(talentCompany, [newCompanyAlert]);
                        }

                        // Add doctor xp
                        let doctorXpGained = null;
                        let ageMultiplier = null;
                        let doctorName = null;
                        if (doctor) {
                            ageMultiplier = getStaffAgeMultiplier(doctor);
                            doctorXpGained = Math.round(15 * ageMultiplier);
                            let doctorLevelIncrease = await updateStaffMemberXp(doctor, doctorXpGained, company, game);
                            doctorName = doctor['name'];
                            if (doctorLevelIncrease) {
                                staffSkillIncreases.push({
                                    'name': doctor['name'],
                                    'level': doctor['level'],
                                    'role': doctor['role']
                                })
                            }
                        }

                        // Check for championships to vacate
                        let championshipsToVacate = [];
                        if (!simulator) {
                            if (talentCompany && talentCompany.userControlled) {
                                championshipsToVacate = await Promise.all((await getSuperstarChampionshipsToVacate(s))
                                    .map(x => getChampionshipMatchData(x)));
                            }
                        } else {
                            // Vacate if simulating
                            await vacateChampionships({
                                superstar: s, championships: companyChampionships, month, year, company,
                                checkTalentRequest: true
                            });
                        }

                        // Get unavailable data
                        unavailable.push({
                            'name': s.name, 'type': 'injury', 'injuryType': injuryData['type'],
                            'doctorXpGained': doctorXpGained, 'doctorName': doctorName,
                            'doctorAgeMultiplier': ageMultiplier, 'uid': s.$loki,
                            'championshipsToVacate': championshipsToVacate, 'injuryChance': injuryData['chance'],
                            'participantName': matchParticipant.name
                        });

                        // Get injury caused by, injured participant
                        let injuryCausedBy = getRandomChoice(matchParticipants.filter(x => x.$loki !== matchParticipant.$loki));
                        let dangerousWorkerTraitSuperstar = getDangerousWorkerSuperstar(opponentSuperstars);
                        let injuredParticipant;
                        if (type === 'singles') {
                            injuredParticipant = s;
                            if (dangerousWorkerTraitSuperstar) {
                                injuryCausedBy = dangerousWorkerTraitSuperstar
                            }
                        } else {
                            // Get tag team for adding feud and companyLog unless it's temporary, then get superstar
                            injuredParticipant = matchParticipant;
                            if (injuryCausedBy.temporary && !injuryCausedBy.trioTagTeam) {
                                if (dangerousWorkerTraitSuperstar) {
                                    injuryCausedBy = dangerousWorkerTraitSuperstar
                                } else {
                                    injuryCausedBy = getRandomChoice(injuryCausedBy.tempSuperstars)
                                }
                                injuredParticipant = s;
                            }
                        }

                        // Check to acquire trait
                        let injuryCausedBySuperstar = injuryCausedBy;
                        if (injuryCausedBy.objectName === 'tagTeam') {
                            injuryCausedBySuperstar = getRandomChoice(injuryCausedBy.tempSuperstars)
                        }
                        if (!workingThroughInjury) {
                            await checkAcquireTrait(s, 'Injury Prone');
                            await checkAcquireTrait(injuryCausedBySuperstar, 'Dangerous Worker');
                        }

                        if (talentCompany) {
                            // Add news
                            let newsType = injuryData['type'] === 'workable' ? 'workable_injury' : 'injury';
                            let newsItem = await generateNewsItem({
                                company: talentCompany, month: game.newsMonth, year: game.newsYear, newsType, superstar: s,
                            });
                            await addCompanyNewsItems(mainCompany, [newsItem]);

                            // Add company log
                            let newLog = CompanyLog(month, year);
                            newLog.text = `${injuryCausedBy.name} injured ${injuredParticipant.name}`;
                            newLog.type = 'injury';
                            await CompanyLogs.insert(newLog);
                            await addCompanyCompanyLogs(talentCompany, [newLog]);
                        }

                        // Add feud if not annual tournament
                        if (!annualTournament) {
                            let newFeudParticipants = [injuredParticipant, injuryCausedBy];
                            let addFeudData = await checkToAddFeud('injury-return', newFeudParticipants,
                                company, mainRoster, month, year);
                            if (addFeudData['key'] === 'feudPotentials') {
                                feudPotentials.push(addFeudData['value'])
                            } else if (addFeudData['key'] === 'feudHypeIncreased') {
                                feudHypeIncreased.push(addFeudData['value'])
                            }
                        }

                        break;
                    }
                }

                // Break injury loop if any superstar injured
                if (unavailable.length > 0) {
                    break;
                }
            }
        }

        // Gimmick match checks
        if (matchGimmick) {

            // Add gimmick match consequences if record affected
            if (affectRecord) {
                const loserParticipant = loserParticipants[0];
                const loserParticipantSuperstars = loserParticipant.tempSuperstars;

                // Make loser unavailable
                if (matchGimmick.consequence === 'loser_unavailable') {
                    let months = getRandomInt(2, 4);
                    for (const s of loserParticipantSuperstars) {
                        addKayfabeInjuryToSuperstar(s, months);
                        unavailable.push({'name': s.name, 'type': 'unavailable'});

                        // Check talent request
                        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: s});
                    }

                    // Add feud
                    let newFeudParticipants = [winnerParticipant, loserParticipant];
                    if (type === 'tag' && (winnerParticipant.factionTagTeam && loserParticipant.factionTagTeam)) {
                        // Get factions if factions in tag match
                        let winnerFaction = (await getSuperstarFactions(winnerSuperstars[0])).find(x => !x.disbanded);
                        let loserFaction = (await getSuperstarFactions(loserParticipantSuperstars[0])).find(x => !x.disbanded);
                        newFeudParticipants = [winnerFaction, loserFaction];
                    }
                    let addFeudData = await checkToAddFeud('loser-leaves', newFeudParticipants,
                        company, mainRoster, month, year);
                    if (addFeudData['key'] === 'feudPotentials') {
                        feudPotentials.push(addFeudData['value'])
                    } else if (addFeudData['key'] === 'feudHypeIncreased') {
                        feudHypeIncreased.push(addFeudData['value'])
                    }
                }

                // Hair removed, hair added or mask removed
                if (['remove_hair', 'remove_mask', 'add_hair'].includes(matchGimmick.consequence)) {
                    for (const s of loserParticipantSuperstars) {
                        let gimmickChangeReason;
                        if (matchGimmick.consequence === 'remove_hair') {
                            if (s.graphic && Object.keys(s.graphic).length !== 0) {
                                s.graphic = removeSuperstarGraphicHair(s.graphic);
                            }
                            hairRemoved.push({'name': s.name, 'possessivePronoun': s.possessivePronoun});
                            gimmickChangeReason = 'Hair Loss';
                        }
                        if (matchGimmick.consequence === 'remove_mask') {
                            if (s.graphic && Object.keys(s.graphic).length !== 0) {
                                s.graphic = removeSuperstarGraphicMask(s.graphic);
                            }
                            maskRemoved.push({'name': s.name, 'possessivePronoun': s.possessivePronoun});
                            gimmickChangeReason = 'Unmasking';
                        }
                        if (matchGimmick.consequence === 'add_hair') {
                            if (s.graphic && Object.keys(s.graphic).length !== 0) {
                                s.graphic = addSuperstarGraphicHair(s.graphic, s.gender);
                            }
                            hairAdded.push({'name': s.name, 'possessivePronoun': s.possessivePronoun});
                        }

                        if (gimmickChangeReason) {
                            // Next gimmick boost chance and message
                            let addedNextGimmickBoost = await addNextGimmickBoost(s, 75);
                            if (addedNextGimmickBoost && company.userControlled) {
                                const talentManager = getRandomStaffMemberByRole(staffMembers, 'talent_manager');
                                let newMessage = await createGimmickChangeBoostMessage(s, gimmickChangeReason, month, year,
                                    talentManager);
                                await addCompanyMessages(company, [newMessage]);
                            }
                        }

                        // Update graphics
                        if (graphics) {
                            graphics = updateMatchOrSegmentGraphics(graphics, s);
                            updateGraphics = true;
                        }

                        // Check talent request
                        await checkTalentRequestAction({company: company, requestType: 'change_appearance', talent: s});
                    }
                }

                // Mask or hair removed
                if (matchGimmick.consequence === 'remove_mask_or_hair') {
                    for (const s of loserParticipantSuperstars) {
                        let gimmickChangeReason = null;
                        if (loserParticipantSuperstars.some(x => checkSuperstarGraphicMask(x.graphic))) {
                            if (checkSuperstarGraphicMask(s.graphic)) {
                                s.graphic = removeSuperstarGraphicMask(s.graphic);
                                maskRemoved.push({'name': s.name, 'possessivePronoun': s.possessivePronoun});
                                gimmickChangeReason = 'Unmasking';
                            }
                        } else if (s.graphic && s.graphic['hair']['object'] !== 0) {
                            s.graphic = removeSuperstarGraphicHair(s.graphic);
                            hairRemoved.push({'name': s.name, 'possessivePronoun': s.possessivePronoun});
                            gimmickChangeReason = 'Hair Loss';
                        }

                        if (gimmickChangeReason) {
                            // Next gimmick boost chance and message
                            let addedNextGimmickBoost = await addNextGimmickBoost(s, 75);
                            if (addedNextGimmickBoost && company.userControlled) {
                                const talentManager = getRandomStaffMemberByRole(staffMembers, 'talent_manager');
                                let newMessage = await createGimmickChangeBoostMessage(s, gimmickChangeReason, month, year,
                                    talentManager);
                                await addCompanyMessages(company, [newMessage]);
                            }

                            // Update graphics
                            if (graphics) {
                                graphics = updateMatchOrSegmentGraphics(graphics, s);
                                updateGraphics = true;
                            }

                            // Check talent request
                            await checkTalentRequestAction({
                                company: company,
                                requestType: 'change_appearance',
                                talent: s
                            });
                        }
                    }
                }
            }

            // Check talent request
            for (const matchSuperstar of matchSuperstars) {
                await checkTalentRequestAction({
                    company: company,
                    requestType: 'be_in_gimmick_match',
                    talent: matchSuperstar
                });
                let requestData = {'gimmickMatchId': matchGimmick.$loki};
                await checkTalentRequestAction({
                    company: company, requestType: 'be_in_gimmick_match_x', talent: matchSuperstar,
                    data: requestData
                });
            }

            // Add xp to gimmick match
            const increase = Math.floor(rating ** 2 * 1.5);
            matchGimmick.xp += increase;

            // Check level increase
            let levelIncrease = false;
            let addedPerk = null;
            if (matchGimmick.level < 3 && matchGimmick.xp >= matchGimmick.level ** 2 * 50) {
                matchGimmick.level += 1;
                levelIncrease = true;
                // Add perk if level increase
                addedPerk = addPerkToGimmickMatch(matchGimmick);
            }

            // Get gimmick match level data
            gimmickMatchLevelData = {
                name: matchGimmick.name,
                xp: matchGimmick.xp,
                xpChange: increase,
                level: matchGimmick.level,
                levelIncrease: levelIncrease,
                addedPerk: addedPerk,
            };

            // Check for unlocked gimmick matches
            unlockedGimmickMatches = checkGimmickMatchesToUnlock(matchGimmick, (await getCompanyGimmickMatches(company)));

            // Add match effect change if paid version
            if (rating !== null && globalUser.paid) {
                if (rating >= 4) {
                    data['matchEffectIncrease'] = true;
                } else {
                    data['matchEffectDecrease'] = true;
                }
            }
            data['matchGimmick'] = matchGimmick.name;

            // Generate text for battle royal etc
            if (matchGimmick.rules === 'battle_royal') {
                generatedText = await generateBattleRoyalMatchResult(match, winnerParticipant, type, matchParticipants, matchSuperstars);
                // Check goal
                if (company.userControlled) {
                    let objectiveCompleted = await changeProperty({
                        name: 'win battle royal', change: 1, company: company,
                        superstarName: winnerParticipant.name
                    });
                    if (objectiveCompleted) {
                        await processObjectiveCompleted(objectiveCompleted, company);
                    }
                }
            } else if (matchGimmick.name === 'Ironman') {
                generatedText = generateIronmanMatchText();
            } else if (matchGimmick.rules === 'elimination') {
                generatedText = generateEliminationMatchResult(winnerParticipant, matchParticipants);
            } else if (matchGimmick.rules === '2/3_falls') {
                generatedText = generateTwoOutOfThreeFallsResult(winnerParticipant, matchParticipants, match.fallGimmickNames);
            }

            // Add generated text to match
            if (generatedText) {
                match.generatedText = generatedText;
            }

            // Check goal
            if (rating !== null && company.userControlled) {
                let objectiveCompleted = await changeProperty({
                    name: 'gimmick matches', change: 1, company: company,
                    rating: rating, gimmickMatchName: matchGimmick.name
                });
                if (objectiveCompleted) {
                    await processObjectiveCompleted(objectiveCompleted, company);
                }
            }

            // Check for first wom story event todo LATER
            if (company.storyName === 'mars' && matchGimmick.name === 'Olympus Mons') {

            }
        }

        // Rank checks
        for (const x of winnerSuperstars) {
            let talentCompany = await getTalentCompany(x);
            let winnerNewRank = getRankFromPopularity(x.popularity);
            if (winnerNewRank !== x.highestRank) {
                // Set highest rank
                let ranks = {'Main Eventer': 4, 'Upper Midcarder': 3, 'Lower Midcarder': 2, 'Jabroni': 1};
                if (ranks[winnerNewRank] || 1 > ranks[x.highestRank] || 1) {
                    x.highestRank = winnerNewRank;

                    // Check Martian Main Eventer Goal if first time Main Eventer todo LATER
                    if (company.userControlled && winnerNewRank === 'Main Eventer' && x.name.includes('(Martian)')) {
                        await changeProperty({name: 'martian main eventers', change: 1, company: company});
                    }

                    // Check goals
                    if (talentCompany && talentCompany.userControlled) {
                        if (winnerNewRank === 'Main Eventer') {
                            let objectiveCompleted = await changeProperty({
                                name: 'main eventer', change: 1,
                                company: talentCompany, superstarName: x.name
                            });
                            if (objectiveCompleted) {
                                await processObjectiveCompleted(objectiveCompleted, talentCompany);
                            }
                            // Find trio
                            let winnerTrio = (await getSuperstarTagTeams(x)).find(y => y.trio);
                            if (winnerTrio) {
                                // Check if all members are main eventers
                                let winnerTrioSuperstars = await getTagTeamSuperstars(winnerTrio);
                                if (winnerTrioSuperstars.every(y => getRankFromPopularity(y.popularity) === 'Main Eventer')) {
                                    let superstarNames = commaSeparate(winnerTrioSuperstars.map(z => z.name)
                                        .sort((a, b) => a.localeCompare(b)));
                                    let objectiveCompleted = await changeProperty({
                                        name: 'new trio', change: 1,
                                        company: talentCompany, superstarName: superstarNames
                                    });
                                    if (objectiveCompleted) {
                                        await processObjectiveCompleted(objectiveCompleted, talentCompany);
                                    }
                                }
                            }
                        } else if (winnerNewRank === 'Upper Midcarder') {
                            let winnerTagTeam = (await getSuperstarTagTeams(x)).find(y => !y.temporary && !y.trio);
                            if (winnerTagTeam) {
                                let winnerTagTeamSuperstars = await getTagTeamSuperstars(winnerTagTeam);
                                if (winnerTagTeamSuperstars.every(y => ['Main Eventer', 'Upper Midcarder']
                                    .includes(getRankFromPopularity(y.popularity)))) {
                                    let superstarNames = commaSeparate(winnerTagTeamSuperstars.map(z => z.name)
                                        .sort((a, b) => a.localeCompare(b)));
                                    let objectiveCompleted = await changeProperty({
                                        name: 'new tag team', change: 1,
                                        company: talentCompany, superstarName: superstarNames
                                    });
                                    if (objectiveCompleted) {
                                        await processObjectiveCompleted(objectiveCompleted, talentCompany);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Check talent request
            if (talentCompany) {
                let requestData = {'reachedRank': winnerNewRank};
                await checkTalentRequestAction({
                    company: talentCompany, requestType: 'go_to_next_rank', talent: x,
                    data: requestData
                });
            }
        }

        // Add next round if tournament
        if (match.tournamentRound) {
            let tournamentWon = false;
            let tournamentWinner;
            let injuryReplacement = false;

            // If winner got injured, put loser through to next round
            const maxUnavailable = winnerParticipant.objectName === 'tagTeam' && winnerParticipant.trioTagTeam ? 1 : 0;
            const injuredTeamSuperstars = winnerSuperstars.filter(x => x.injured > 0);
            let participantGoingThrough = injuredTeamSuperstars.length > maxUnavailable ?
                loserParticipants[0] : winnerParticipant;

            // Replace injured winner during annual tournament (except final)
            if (annualTournament && winnerParticipant.injured > 0 && match.tournamentRound !== tournament.rounds) {
                const activeCompanies = await getGameActiveCompanies(game);
                const winnerParticipantCompany = getAnnualTournamentParticipantOrganization(winnerParticipant, tournament,
                    activeCompanies);

                // Add injury to companiesData
                addAnnualTournamentInjuredParticipantId(tournament, winnerParticipant.$loki);

                if (winnerParticipantCompany && winnerParticipantCompany.userControlled && !simulator) {
                    // Prompt user for replacement
                    data['annualTournamentDialogData'] = await getAnnualTournamentDialogData(tournament, company, mainCompany,
                        game, null);

                    // Don't add participant to next round
                    participantGoingThrough = null;

                    // Add injury message for champion
                    if ((await getSuperstarChampionships(winnerParticipant)).length > 0) {
                        const newMessage = await createPresidentChampionInjuryMessage(winnerParticipant, game, month, year);
                        await addCompanyMessages(winnerParticipantCompany, [newMessage]);
                    }
                } else {
                    // Select CPU replacement
                    const participantReplacement = await getAnnualTournamentCpuReplacement(tournament, winnerParticipantCompany,
                        mainCompany);
                    let participantReplacementId = null;

                    // Set replacement as participant going through
                    if (participantReplacement) {
                        participantReplacementId = participantReplacement.$loki;
                        injuryReplacement = true;
                        participantGoingThrough = participantReplacement;
                    }

                    // Replace in companiesData
                    addAnnualTournamentInjuryReplacement(tournament, winnerParticipant.$loki, participantReplacementId);
                }
            }

            // Elimination
            if (tournament.type === 'elimination' || tournament.stage === 'elimination') {
                newTournamentRound = true;
                // Get next round matches, add winner to next round
                const nextRoundMatches = await getNextRoundMatches(tournament, match.tournamentRound);
                if (nextRoundMatches.length > 0 && participantGoingThrough) {
                    await addWinnerToNextRound(nextRoundMatches, participantGoingThrough, event, false,
                        rosterSuperstars, annualTournament);

                    // Injury notification. Don't show if one trio member injured in tag tournament
                    if (injuredTeamSuperstars.length > maxUnavailable) {
                        data['tournamentInjury'] = {
                            injured: winnerParticipant.name, 'injuredPronoun': winnerParticipant.pronoun,
                            participantGoingThrough: participantGoingThrough.name, tournamentName: tournament.name,
                            type: 'elimination', 'replacement': injuryReplacement
                        };
                    }
                }

                // Check for final round
                if (match.tournamentRound === tournament.rounds) {
                    tournamentWon = true;
                    tournamentWinner = winnerParticipant;
                }

                // Substitute trio member for tag tournament injury
                if (winnerParticipant.objectName === 'tagTeam' && winnerParticipant.trioTagTeam && injuredTeamSuperstars.length > 0 &&
                    participantGoingThrough && participantGoingThrough.$loki === winnerParticipant.$loki) {
                    for (const m of nextRoundMatches) {
                        const mp = await getMatchParticipants(m);
                        if (objectInArray(winnerParticipant, mp)) {
                            const trio = (await getSuperstarTagTeams(winnerSuperstars[0])).find(x => x.trio);
                            const newMember = (await getTagTeamSuperstars(trio)).find(x => !objectInArray(x, winnerSuperstars));

                            // Add new member, remove old member, rename team
                            await removeSuperstarFromTagTeam(winnerParticipant, injuredTeamSuperstars[0]);
                            await addTagTeamSuperstars(winnerParticipant, [newMember]);
                            const newMembers = await getTagTeamSuperstars(winnerParticipant);
                            winnerParticipant.name = `${trio.name} (${commaSeparate(newMembers.map(x => getSuperstarLastName(x)))})`;

                            // Add data
                            data['tournamentSubstitution'] = {
                                injured: injuredTeamSuperstars[0].name,
                                newMember: newMember.name,
                                tournamentName: tournament.name,
                                possessivePronoun: injuredTeamSuperstars[0].possessivePronoun
                            };
                        }
                    }
                }
            }

            // Add group points
            if (tournament.type === 'round-robin') {
                if (matchFinish && matchFinish['draw']) {
                    winnerParticipant.tournamentPoints += 1;
                    loserParticipants[0].tournamentPoints += 1;
                } else {
                    winnerParticipant.tournamentPoints += 2;
                }

                // Check for final group round
                let tournamentRounds = tournament.rounds;
                // Subtract knockout rounds if any participants advancing
                if (tournament.participantsAdvancing !== 0) {
                    tournamentRounds -= tournament.knockoutRounds;
                }

                if (match.tournamentRound === tournamentRounds) {
                    // Check if final match of group and round
                    const roundMatches = (await getTournamentMatches(tournament))
                        .filter((x) => x.tournamentGroup === match.tournamentGroup && x.tournamentRound === match.tournamentRound);
                    if (match.$loki === roundMatches[0].$loki) {  // Reversed order
                        newTournamentRound = true;
                        // No knockout stage
                        if (tournament.participantsAdvancing === 0) {
                            tournamentWon = true;
                            tournamentWinner = (await getAdvancingParticipants(tournament, match.tournamentGroup))[0];
                        }
                        // Knockout stage
                        else {
                            const advancingParticipants = await getAdvancingParticipants(tournament, match.tournamentGroup,
                                tournament.participantsAdvancing);
                            // Add advancing participants to next round
                            const nextRoundMatches = await getNextRoundMatches(tournament, match.tournamentRound);
                            for (const x of advancingParticipants) {
                                await addWinnerToNextRound(nextRoundMatches, x, event, true, rosterSuperstars);
                            }

                            // Show advancing
                            data['tournamentAdvance'] = {
                                'names': advancingParticipants.map(x => x.name),
                                'group': match.tournamentGroup
                            };

                            // Change to elimination stage if last match of last group
                            if (match.tournamentGroup === tournament.numberOfGroups || match.tournamentGroup === 0) {
                                tournament.stage = 'elimination';
                            }
                        }
                    }
                }

                // Injury notification
                if (!tournamentWon) {
                    for (const x of matchParticipants) {
                        if (unavailable.map(y => y['participantName']).includes(x.name)) {
                            data['tournamentInjury'] = {
                                injured: x.name,
                                tournamentName: tournament.name,
                                type: 'round-robin'
                            };
                        }
                    }
                }
            }

            // Tournament win
            if (tournamentWinner) {
                if (tournamentWinner.objectName === 'superstar') {
                    await addSuperstarWonTournaments(tournamentWinner, [tournament])
                }
                if (tournamentWinner.objectName === 'tagTeam') {
                    await addTagTeamWonTournaments(tournamentWinner, [tournament])
                }
                tournament.winnerName = tournamentWinner.name;
                data['tournamentWon'] = {
                    'name': tournamentWinner.name,
                    'tournamentName': tournament.name
                };

                if (annualTournament) {
                    // Add trophy presentation segment
                    const annualTournamentWinnerSegment = getAnnualTournamentWinnerSegmentData(game, tournament, tournamentWinner);
                    data['matches'] = [annualTournamentWinnerSegment];

                    // Update morale for annual tournament win
                    const moraleChange = await getSuperstarMoraleChange({changeType: 'annual_tournament_won'});
                    updateSuperstarMorale(tournamentWinner, moraleChange);
                }

                // Check for tournament match contract
                const matchContracts = await getTournamentMatchContracts(tournament);
                if (matchContracts.length > 0) {
                    // Add to winner
                    await addTalentMatchContracts(tournamentWinner, [matchContracts[0]]);
                    data['tournamentWon']['matchContractName'] = matchContracts[0].name;
                }
            }

            // Check whether to add tournament to next event
            const tournamentEvent = await getTournamentEvent(tournament);
            if (tournamentEvent && (tournamentEvent.name === 'Weekly Show' ||
                (annualTournament && tournamentEvent.name[tournamentEvent.name.length - 1] === '1'))) {
                const companyEvents = await getCompanyEvents(company);
                const nextEvent = companyEvents[companyEvents.length - 2];
                await addEventTournaments(nextEvent, [tournament]);
            }
        }

        // Add win/loss record
        if (affectRecord) {
            winnerParticipant.wins += 1;
            winnerParticipant.winsCounter += 1;
            winnerParticipant.winsTemporary += 1;
            winnerParticipant.lossesCounter = 0;
            for (const x of loserParticipants) {
                x.losses += 1;
                x.lossesCounter += 1;
                x.lossesTemporary += 1;
                x.winsCounter = 0;
                // Unlock special segment
                if (x.objectName === 'superstar' && x.lossesCounter >= 10 && x.hot) {
                    let talentCompany = await getTalentCompany(x);
                    if (talentCompany) {
                        await unlockSpecialSegment(talentCompany, 'Ring Invasion', month, year);
                    }
                }
            }
        }

        // Check talent requests if not annual tournament
        if (!annualTournament) {
            // Check for clean finish requests
            if (!matchFinish || ['Squash', 'Respectful End', 'By Any Means'].includes(matchFinish['name'])) {
                for (const loserParticipant of loserParticipants) {
                    await checkTalentRequestAction({
                        company: company, requestType: 'no_clean_loss', talent: loserParticipant,
                        failRequest: true
                    });
                    let requestData = {'talentId': winnerParticipant.$loki};
                    await checkTalentRequestAction({
                        company: company, requestType: 'put_x_over_clean', talent: loserParticipant,
                        data: requestData
                    });
                }
                let requestData = {'talentId': loserParticipants[0].$loki};
                await checkTalentRequestAction({
                    company: company, requestType: 'beat_x_clean', talent: winnerParticipant,
                    data: requestData
                });
                await checkTalentRequestAction({
                    company: company, requestType: 'win_and_not_lose', talent: winnerParticipant,
                    secondaryAction: true
                });
            }

            // Check for winning/losing requests
            await checkTalentRequestAction({
                company: company,
                requestType: 'win_next_match',
                talent: winnerParticipant
            });
            await checkTalentRequestAction({
                company: company, requestType: 'lose_next_match', talent: winnerParticipant,
                failRequest: true
            });
            for (const loserParticipant of loserParticipants) {
                await checkTalentRequestAction({
                    company: company, requestType: 'win_and_not_lose', talent: loserParticipant,
                    failRequest: true
                });
                await checkTalentRequestAction({
                    company: company,
                    requestType: 'lose_next_match',
                    talent: loserParticipant
                });
                await checkTalentRequestAction({
                    company: company, requestType: 'win_next_match', talent: loserParticipant,
                    failRequest: true
                });
            }

            // Check for beat main eventer request
            if ((await getRosterMemberRank(loserParticipants[0])) === 'Main Eventer') {
                await checkTalentRequestAction({
                    company: company,
                    requestType: 'beat_main_eventer',
                    talent: winnerParticipant
                })
            }

            // Check for match request
            for (const x of matchParticipants) {
                let otherParticipant = matchParticipants.find(y => y.$loki !== x.$loki);
                if (otherParticipant) {
                    let requestData = {'talentId': otherParticipant.$loki};
                    await checkTalentRequestAction({
                        company: company,
                        requestType: 'match_with_x',
                        talent: x,
                        data: requestData
                    });
                }
            }
        }

        // Add tournament prestige data except for annual tournament, check for end of tournament
        if (tournament && !annualTournament && match.tournamentRound === tournament.rounds && globalUser.paid) {
            // Update tournament's xp
            tournament.xp += await getTournamentXpChange(tournament);

            // Update tournament's prestige
            const [prestigeIncrease, prestigeDecrease] = updateTournamentPrestige(tournament);

            // Add prestige data
            data['tournamentPrestige'] = {
                'prestige': tournament.prestige,
                'xp': tournament.xp,
                'xpChange': tournament.xp - tournament.startingXp,
                'baseXp': eventPrestigeXps[tournament.prestige],
                'xpToNextPrestige': tournament.prestige === 'C' ? 40 : 110,
                'prestigeIncrease': prestigeIncrease,
                'prestigeDecrease': prestigeDecrease,
                'finalBonus': getTournamentFinalBonus(tournament)
            };

            // Update starting xp
            tournament.startingXp = tournament.xp;
        }

        // Process feuds
        let feuds = [];
        let feudItemsLevelData = [];
        let unlockedFeudItems = [];

        // Get base hype change
        let baseHypeChange = 0;
        if (match.rating !== null) {
            let ratingMultiplier = (match.rating - 3);
            baseHypeChange = ratingMultiplier * 3;
            if (weeklyShow) {
                baseHypeChange *= 0.6;
            }
            baseHypeChange = Math.floor(baseHypeChange);
        }

        // Add match finish boost to hype change
        if (matchFinish && matchFinish['consequences']) {
            if (matchFinish['consequences'].includes('feud_boost')) {
                baseHypeChange += getRandomInt(20, 30);
            }
        }

        for (const feud of matchFeuds) {
            // Skip ended feuds (e.g ended in match before this)
            if (feud.ended) {
                continue;
            }

            // Get participants and superstars
            let feudParticipants = await getFeudParticipants(feud);
            let feudSuperstars = (await Promise.all(feudParticipants.map(x => getRosterMemberSuperstars(x)))).flat();

            // Check hot
            let hotFeud = checkFeudHot(feud, match.rating, feudSuperstars);
            let hotFeudHypeBoost = 0;
            if (hotFeud) {
                hotFeudHypeBoost = getRandomInt(15, 20);
                if (feudParticipants.map(x => x.name).includes(company.ownerName)) {
                    await unlockSpecialSegment(company, 'Anti-Company Rant', month, year);
                }
            }

            let started;
            const feudItem = await getFeudFeudItem(feud);
            if (!feud.started) {
                // Start feud
                started = false;
                feud.started = true;
                if (feud.startMonth === null) {
                    feud.startMonth = month;
                    feud.startYear = year;
                }
                // Remove any added blowoffs
                feud.runBlowoff = false;

                // Add hype
                let boosts = await getFeudCreationBoosts(feud, feudParticipants, month, year, company.style);
                feud.hype = feudItem.baseHype + boosts['hypeBoost'];

                // Get feud started data
                feudsStarted.push({
                    'name': feud.name,
                    'participants': feudParticipants.map(x => x.name),
                    'boosts': boosts,
                    'baseHype': feudItem.baseHype
                });

                // Check talent request and update morale
                for (const feudParticipant of feudParticipants) {
                    let otherFeudParticipant = feudParticipants.find(x => x.$loki !== feudParticipant.$loki);
                    if (otherFeudParticipant) {
                        // Check feud_with_x talent request
                        let requestData = {'talentId': otherFeudParticipant.$loki};
                        await checkTalentRequestAction({
                            company: company, requestType: 'feud_with_x', talent: feudParticipant,
                            data: requestData
                        });

                        // Update morale for feud started
                        let popularityDifference = (await getRosterMemberPopularity(feudParticipant)) -
                            (await getRosterMemberPopularity(otherFeudParticipant));
                        let moraleChange = await getSuperstarMoraleChange({
                            changeType: 'feud_started',
                            popularityDifference: popularityDifference,
                            feudParticipants: [feudParticipant, otherFeudParticipant]
                        });
                        for (let s of (await getRosterMemberSuperstars(feudParticipant))) {
                            updateSuperstarMorale(s, moraleChange);
                        }
                    }
                }
            } else {
                started = true;
                let feudBlowoffTypeCheck = await checkFeudBlowoffMatchParticipantType(feudParticipants, matchParticipants,
                    type, feudItem.consequence);
                if (feud.runBlowoff && !feud.ended && feudBlowoffTypeCheck) {
                    // End feud
                    feud.ended = true;
                    feud.endMonth = month;
                    feud.endYear = year;
                    feud.runBlowoff = false;

                    // Get rating
                    feud.rating = await getFeudRating(feud);

                    // Get winner and loser
                    let feudWinner = winnerParticipant;
                    let feudLoser = loserParticipants[0];

                    // Overness changes
                    if (feud.hype > 0) {
                        let overnessIncrease = Math.round(feud.hype / 20.0);
                        if (overnessIncrease > 10) {
                            overnessIncrease = 10;
                        }
                        for (let s of feudWinner.tempSuperstars) {
                            updateOverness(s, overnessIncrease);
                        }
                        let overnessDecrease = Math.round(feud.hype / 30.0) * -1;
                        if (overnessDecrease < -5) {
                            overnessDecrease = -5;
                        }
                        for (let s of feudLoser.tempSuperstars) {
                            updateOverness(s, overnessDecrease);
                        }
                    }

                    // Run consequence EA todo
                    if (feudItem.consequence) {
                        data['feudConsequenceResults'] = await runFeudConsequence(feud, feudWinner, feudLoser, company,
                            mainCompany, game, mainRoster, indieRoster, match, month, year, graphics, type);
                        const feudConsequenceResults = data['feudConsequenceResults'];
                        vacated.push(...feudConsequenceResults['vacated']);
                        feudPotentials.push(...feudConsequenceResults['feudPotentials']);
                        feudHypeIncreased.push(...feudConsequenceResults['feudHypeIncreased']);
                        unlockedChampionshipSegmentItems.push(...feudConsequenceResults['unlockedChampionshipSegmentItems']);
                        graphics = feudConsequenceResults['graphics'];
                        factionConsequences = feudConsequenceResults['factionConsequences'];
                        factionReputationsData.push(...feudConsequenceResults['factionReputationsData']);
                        updateGraphics = true;
                    }

                    // Check to unlock special segment
                    if (feud.rating >= 4.5 && feud.name.toLowerCase().includes('family')) {
                        await unlockSpecialSegment(company, 'Car Explosion', month, year);
                    }

                    // Update faction rep
                    if (feudParticipants[0].objectName === 'faction') {
                        let winningFaction;
                        for (const faction of feudParticipants) {
                            let factionSuperstars = await getFactionSuperstars(faction);
                            if (feudWinner.tempSuperstars.every(s => objectInArray(s, factionSuperstars))) {
                                winningFaction = faction;
                                break;
                            }
                        }
                        if (winningFaction) {
                            const factionData = await processFactionXpChangeForFaction({
                                faction: winningFaction,
                                feudWon: feud
                            });
                            if (factionData) {
                                factionReputationsData.push(factionData);
                            }
                            const losingFaction = feudParticipants.find(y => y.$loki !== winningFaction.$loki);
                            if (losingFaction) {
                                const factionData = await processFactionXpChangeForFaction({
                                    faction: losingFaction,
                                    feudLost: feud
                                });
                                if (factionData) {
                                    factionReputationsData.push(factionData);
                                }
                            }
                        }
                    }
                }
            }

            // Get feud superstars present in match
            const feudSuperstarsPresentInMatch = feudSuperstars.filter(x => objectInArray(x, matchSuperstars));

            // Get trait boost for feud hype change
            let feudHypeTraitBoost = 0;
            for (const feudSuperstar of feudSuperstarsPresentInMatch) {
                for (const trait of feudSuperstar.traits) {
                    const traitData = traitsData[trait];
                    if (traitData && traitData['feud_hype_change_boost']) {
                        feudHypeTraitBoost += traitData['feud_hype_change_boost'];
                    }
                }
            }
            feudHypeTraitBoost = limitValueBetweenRange(feudHypeTraitBoost, -6, 6);

            // Check staleness
            let stale = false;
            let staleWarning = false;
            let stalenessHypeDecrease = 0;
            let staleFeudOvernessDecrease = 0;
            const staleLength = await getMatchesForStaleFeud(feud, feudParticipants);

            // Decrease hype if stale
            if (feud.stale) {
                stalenessHypeDecrease = Math.round(feud.stalenessCounter * -1.5);
            }

            // Check for feud staleness
            if (feud.stalenessCounter >= staleLength && !feud.stale) {
                staleWarning = true;
                if (feud.stalenessCounter > staleLength) {
                    stale = true;
                    feud.stale = true;
                    feud.hot = false;
                    stalenessHypeDecrease = Math.round((feud.stalenessCounter ** 1.5) * -1);

                    // Decrease overness for superstars
                    staleFeudOvernessDecrease = Math.floor(feud.stalenessCounter * 2);
                    staleFeudOvernessDecrease = limitValueBetweenRange(staleFeudOvernessDecrease, staleFeudOvernessDecrease, 16);
                    staleFeudOvernessDecrease *= -1;
                    for (let s of feudSuperstars) {
                        updateOverness(s, staleFeudOvernessDecrease);
                    }
                }
            }

            // Add hype change to feud
            let feudHypeChange = baseHypeChange + hotFeudHypeBoost + feudHypeTraitBoost + stalenessHypeDecrease;
            feudHypeChange = Math.round(feudHypeChange);
            if (feudHypeChange) {
                feud.hype += feudHypeChange;
            }

            // Add to staleness counter
            let stalenessEffect = 1;
            if (matchFinish) {
                stalenessEffect = matchFinish['feudStalenessEffect'];
            }
            if (weeklyShow) {
                stalenessEffect /= 2.0;
            }
            feud.stalenessCounter += stalenessEffect;

            // XP/Prestige if ended
            if (feud.started && feud.ended && feud.rating !== null && globalUser.paid) {
                let levelIncrease = false;
                let feudItemHypeIncrease = 0;

                // Add xp
                const increase = Math.floor(feud.rating ** 2);
                feudItem.xp += increase;

                // Check level increase
                if (feudItem.level < 3) {
                    if (feudItem.xp >= feudItem.level ** 2 * 40) {
                        // Increase base hype
                        feudItemHypeIncrease = feudItem.level * 5;
                        feudItem.baseHype += feudItemHypeIncrease;
                        feudItem.level += 1;
                        levelIncrease = true;
                    }
                }

                // Get data
                const feudItemLevelData = {
                    name: feudItem.name,
                    xp: feudItem.xp,
                    xpChange: increase,
                    level: feudItem.level,
                    levelIncrease: levelIncrease,
                    hypeIncrease: feudItemHypeIncrease
                };
                feudItemsLevelData.push(feudItemLevelData);

                const unlocked = checkFeudItemsToUnlock(feudItem, (await getCompanyFeudItems(company)));
                unlockedFeudItems.push(...unlocked);
            }

            // Get feud data
            const feudData = {
                name: feud.name,
                participants: feudParticipants.map(x => x.name),
                started: started,
                runBlowoff: feud.runBlowoff,
                hype: feud.hype,
                baseHype: feud.hype - feudHypeChange,
                hypeChange: feudHypeChange,
                ended: feud.ended,
                stale: stale,
                staleWarning: staleWarning,
                rating: feud.rating,
                hot: hotFeud,
                overnessDecrease: staleFeudOvernessDecrease * -1
            };
            feuds.push(feudData);

            if (hotFeud) {
                // Increase overness for superstars
                const overnessIncrease = getRandomInt(3, 5);
                for (let s of feudSuperstars) {
                    updateOverness(s, overnessIncrease);
                }
                feudData['overnessIncrease'] = overnessIncrease;

                // Update morale for hot feud
                for (const x of matchSuperstars) {
                    const moraleChange = await getSuperstarMoraleChange({changeType: 'hot_feud'});
                    updateSuperstarMorale(x, moraleChange);
                }

                hotFeuds.push(feudData);
            }
        }

        // Check to acquire traits
        if (rating !== null) {
            if (matchParticipants.length === 2) {
                if (!weeklyShow && rating >= 5) {
                    for (let x of matchSuperstars) {
                        await checkAcquireTrait(x, 'Big Match Specialist');
                    }
                }
                if (rating >= 4 && (await getRosterMemberRank(winnerParticipant)) === 'Upper Midcarder') {
                    for (let x of loserParticipants[0].tempSuperstars) {
                        await checkAcquireTrait(x, 'Star Maker');
                    }
                }
                if (rating >= 4.5 && (await getRosterMemberRank(winnerParticipant)) === 'Main Eventer') {
                    for (let x of loserParticipants[0].tempSuperstars) {
                        await checkAcquireTrait(x, 'Spotlight Lover');
                    }
                }
                if (matchGimmick && rating >= 5) {
                    for (let x of matchSuperstars) {
                        await checkAcquireTrait(x, 'Match Expert', matchGimmick.name);
                    }
                }
            }
            if (rating >= 4.5 && ratingData['positiveBoostName']) {
                for (let x of matchSuperstars) {
                    await checkAcquireTrait(x, 'Ring General');
                }
            }
            if (rating <= 2.5 && ratingData['negativeBoostName']) {
                for (let x of matchSuperstars) {
                    await checkAcquireTrait(x, 'Dull Worker');
                }
            }
        }
        if (hotMatch) {
            for (let x of matchSuperstars) {
                await checkAcquireTrait(x, 'Workhorse');
            }
        }

        // Check rating goal and add news
        if (!weeklyShow && rating !== null) {
            // Check goal
            if (company.userControlled) {
                let objectiveCompleted = await changeProperty({
                    name: 'matches',
                    change: 1,
                    company: company,
                    rating: rating
                });
                if (objectiveCompleted) {
                    await processObjectiveCompleted(objectiveCompleted, company);
                }
            }

            // Add news
            if (rating >= 4.5) {
                let newsItem = await generateNewsItem({
                    company, month: game.newsMonth, year: game.newsYear, superstar: winnerParticipant,
                    newsType: 'high_match_rating', event: event, matchParticipants: matchParticipants
                });
                if (annualTournament) {
                    newsItem.companyName = 'TGI'
                }
                await addCompanyNewsItems(mainCompany, [newsItem]);
            } else if (rating < 2) {
                let newsItem = await generateNewsItem({
                    company, month: game.newsMonth, year: game.newsYear, superstar: winnerParticipant,
                    newsType: 'low_match_rating', event: event, matchParticipants: matchParticipants
                });
                if (annualTournament) {
                    newsItem.companyName = 'TGI'
                }
                await addCompanyNewsItems(mainCompany, [newsItem]);
            }
        }

        // Process workrate xp changes
        data['workrateIncreases'] = [];
        const trainer = getHighestLevelStaffMemberByRole(staffMembers, 'trainer');
        const trainerLevel = trainer ? trainer.level : 1;
        let xpGained = getWorkrateXP(rating, match.order, trainerLevel);
        if (weeklyShow) {
            xpGained = Math.floor(xpGained * 0.4);
        }
        for (let p of matchParticipants) {
            await processMatchParticipantWorkrateXp(p, xpGained);
        }

        // Increase overness for hot match
        if (hotMatch) {
            let overnessIncrease = Math.round(8.0 / matchParticipants.length);
            if (weeklyShow) {
                overnessIncrease = Math.round(overnessIncrease * 0.7);
            }
            if (overnessIncrease < 1) {
                overnessIncrease = 1;
            }
            data['hotMatchOvernessIncrease'] = overnessIncrease;

            for (let x of matchSuperstars) {
                updateOverness(x, overnessIncrease);
            }

            // Update morale for hot match
            for (let x of matchSuperstars) {
                let moraleChange = await getSuperstarMoraleChange({changeType: 'hot_match'});
                updateSuperstarMorale(x, moraleChange);
            }
        }

        // Decrease overness for bad match
        if (match.rating !== null && match.rating < 2) {
            let overnessDecrease = Math.round(12.0 / matchParticipants.length);
            if (weeklyShow) {
                overnessDecrease = Math.round(overnessDecrease * 0.7);
            }
            if (overnessDecrease < 1) {
                overnessDecrease = 1;
            }
            overnessDecrease *= -1;

            for (let x of matchSuperstars) {
                updateOverness(x, overnessDecrease);
            }
        }

        // Update morale for main event
        if (mainEvent && !annualTournament) {
            for (let x of matchSuperstars) {
                let moraleChange = await getSuperstarMoraleChange({changeType: 'main_event', weeklyShow: weeklyShow});
                updateSuperstarMorale(x, moraleChange);

                // Check main event request
                await checkTalentRequestAction({company: company, requestType: 'be_in_main_event', talent: x});
            }
        }

        // Check no weekly shows request
        if (weeklyShow && !annualTournament) {
            for (let x of matchSuperstars) {
                await checkTalentRequestAction({
                    company: company,
                    requestType: 'no_weekly_shows',
                    talent: x,
                    failRequest: true
                });
            }
        }

        // Check title match request
        if (matchChampionships.length > 0) {
            for (let x of matchSuperstars) {
                await checkTalentRequestAction({company: company, requestType: 'be_in_title_match', talent: x});
            }
        }

        // Check morale changes
        data['moraleChanges'] = [];
        for (let p of matchParticipants) {
            // Add morale change to participant's data
            let participantData;
            if (p.$loki === winnerData['uid']) {
                participantData = winnerData;
            } else {
                participantData = losersData.find(x => x['uid'] === p.$loki);
            }
            participantData['moraleChange'] = Math.round(p.tempSuperstars.reduce((n, x) => n + (x.morale - x.startingMorale), 0) /
                p.tempSuperstars.length * 10) / 10;

            // Check for morale level change for superstars
            for (const s of p.tempSuperstars) {
                let startingMoraleText = getMoraleText(s.startingMorale);
                let endingMoraleText = getMoraleText(s.morale);
                if (endingMoraleText !== startingMoraleText) {
                    data['moraleChanges'].push({
                        name: s.name, previousMorale: startingMoraleText,
                        currentMorale: endingMoraleText, morale: s.morale
                    });
                }

                // Delete starting morale attribute
                delete s.startingMorale;
            }
        }

        // Check hot and stale changes
        data['hotChanges'] = [];
        data['staleChanges'] = [];
        data['unlockedCharacters'] = [];
        for (let p of matchParticipants) {
            // Add overness change to participant's data
            let participantData;
            if (p.$loki === winnerData['uid']) {
                participantData = winnerData;
            } else {
                participantData = losersData.find(x => x['uid'] === p.$loki);
            }
            participantData['overnessChange'] = Math.round(p.tempSuperstars.reduce((n, x) => n + (x.overness - x.startingOverness), 0) /
                p.tempSuperstars.length * 10) / 10;

            // Check for overness level change for superstars
            for (const s of p.tempSuperstars) {
                const startingOvernessText = getOvernessText(s.startingOverness);
                const endingOvernessText = getOvernessText(s.overness);
                if (endingOvernessText !== startingOvernessText) {
                    overnessChanges.push({
                        name: s.name,
                        previousOverness: startingOvernessText,
                        currentOverness: endingOvernessText,
                        overness: s.overness,
                        increase: s.overness > s.startingOverness
                    });
                }
                const superstarOvernessChange = s.overness - s.startingOverness;

                // Check hot
                const talentCompany = await getTalentCompany(p);
                const hotCheck = checkObjectHot(s, superstarOvernessChange);
                if (hotCheck) {
                    data['hotChanges'].push({name: s.name, pronoun: s.possessivePronoun, status: hotCheck});

                    // Check for character unlock upon hot
                    if (globalUser.paid && hotCheck === 'hot') {
                        const superstarGimmick = await getSuperstarCurrentGimmick(s);
                        if (superstarGimmick) {
                            if (superstarGimmick.character) {
                                const unlockedCharacter = checkCharacterToUnlock(superstarGimmick.character);
                                if (unlockedCharacter) {
                                    data['unlockedCharacters'].push({
                                        name: unlockedCharacter,
                                        originalCharacter: superstarGimmick.character
                                    });
                                }
                            }
                        }
                    }

                    if (hotCheck === 'hot') {
                        // Add news
                        if (talentCompany) {
                            let newsItem = await generateNewsItem({
                                company: talentCompany, month: game.newsMonth, year: game.newsYear, superstar: s,
                                newsType: 'over_superstar',
                            });
                            await addCompanyNewsItems(mainCompany, [newsItem]);
                        }

                        if (talentCompany && talentCompany.userControlled) {
                            // Check goal
                            let objectiveCompleted = await changeProperty({
                                name: 'get over', change: 1, company: talentCompany,
                                superstarName: s.name
                            });
                            if (objectiveCompleted) {
                                await processObjectiveCompleted(objectiveCompleted, talentCompany);
                            }

                            // Add TGI president's message
                            if (getRandomInt(0, 100) <= 25) {
                                let annualTournamentHeld = (await getCompanyTournaments(mainCompany))
                                    .find(y => y.annualTournament && y.status === 'ended');
                                if (annualTournamentHeld) {
                                    const newMessage = await createPresidentOverSuperstarMessage(s, game, month, year);
                                    await addCompanyMessages(talentCompany, [newMessage]);
                                }
                            }
                        }

                        // Update faction rep (overness change)
                        const superstarFactionsData = await processFactionXpChangeForSuperstar({
                            superstar: s,
                            overnessChange: 'hot'
                        });
                        factionReputationsData.push(...superstarFactionsData);
                    }
                }

                // Check stale
                const staleCheck = checkObjectStale(s, superstarOvernessChange);
                if (staleCheck) {
                    data['staleChanges'].push({name: s.name, pronoun: s.possessivePronoun, status: staleCheck});

                    if (staleCheck === 'stale') {
                        if (talentCompany) {
                            let newsItem = await generateNewsItem({
                                company: talentCompany, month: game.newsMonth, year: game.newsYear, superstar: s,
                                newsType: 'stale_superstar'
                            });
                            await addCompanyNewsItems(mainCompany, [newsItem]);
                        }

                        // Update faction rep (overness change)
                        const superstarFactionsData = await processFactionXpChangeForSuperstar({
                            superstar: s,
                            overnessChange: 'stale'
                        });
                        factionReputationsData.push(...superstarFactionsData);
                    }
                }

                // Delete starting overness attribute
                delete s.startingOverness;
            }
        }

        // Run interference effects
        if (interferingMember) {

            // Add popularity to interfering member superstars
            const interferencePopularityIncrease = getRandomInt(2, 4);
            let interferingSuperstars;
            if (interferingMember.objectName === 'faction') {
                // Get available faction members not present in match
                interferingSuperstars = (await getFactionSuperstars(interferingMember))
                    .filter(y => checkSuperstarSegmentAvailability(y)
                        && checkSuperstarBrandAvailability(event, y,
                            getSuperstarChampionshipsFromCompanyChampionships(y, companyChampionships)))
            } else {
                interferingSuperstars = await getRosterMemberSuperstars(interferingMember);
            }
            interferingSuperstars = interferingSuperstars.filter(x => !objectInArray(x, matchSuperstars));
            for (const x of interferingSuperstars) {
                x.popularity += Math.round(interferencePopularityIncrease / interferingSuperstars.length);
            }
            data['interferencePopularityIncrease'] = interferencePopularityIncrease;

            // Get feuds for interference
            let interferingSuperstarsForFeud = [...interferingSuperstars];
            interferingSuperstarsForFeud.push(...matchSuperstars);
            interferingSuperstarsForFeud = getUniqueObjects(interferingSuperstarsForFeud);
            let interferingTeamsForFeud = [];
            for (const s of interferingSuperstarsForFeud) {
                interferingTeamsForFeud.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
            }
            interferingTeamsForFeud = getUniqueObjects(interferingTeamsForFeud);
            const interferenceFeuds = (await getParticipantFeuds(interferingSuperstarsForFeud, interferingTeamsForFeud))
                .filter(x => !objectInArray(x, matchFeuds));

            // Boost interference feuds hype
            const interferenceFeudHypeIncrease = getRandomInt(1, 2);
            for (const x of interferenceFeuds) {
                x.hype += interferenceFeudHypeIncrease;
            }

            data['interferenceFeuds'] = interferenceFeuds.map(y => ({
                name: y.name, hype: y.hype,
                hypeChange: interferenceFeudHypeIncrease
            }));
        }

        // Process match finish
        if (matchFinish) {

            // Run match finish consequences
            if (matchFinish['consequences']) {
                if (matchFinish['consequences'].includes('face_turns_heel')) {
                    for (let s of winnerSuperstars) {
                        await turnRosterMember(s, 'heel', company);
                    }
                    turnedHeel.push(winnerParticipant.name);
                }
                if (matchFinish['consequences'].includes('heel_turns_face')) {
                    for (let s of loserParticipants[0].tempSuperstars) {
                        await turnRosterMember(s, 'face', company);
                    }
                    turnedFace.push(loserParticipants[0].name);
                }
                if (matchFinish['consequences'].includes('manager_leaves_loser_and_joins_winner')) {
                    // Get managed superstars
                    let managedSuperstars = [...loserParticipants[0].tempSuperstars];

                    // Get manager
                    let managerIdSuperstar = managedSuperstars.find(s => {
                        return managedSuperstars.every(y => y.managerId === s.managerId);
                    });
                    if (managerIdSuperstar) {
                        let manager = rosterSuperstars.find(x => x.$loki === managerIdSuperstar.managerId);
                        if (manager) {
                            // Remove managed superstars from manager
                            await removeSuperstarsFromManager(manager, managedSuperstars);
                            managersRemoved.push({
                                'managerName': manager.name,
                                'removedSuperstarsNames': managedSuperstars.map(x => x.name),
                            });

                            // Add superstars to manager if checks passed
                            let superstarsToManage = [...winnerSuperstars];
                            if (superstarsToManage.every(s => !s.managerId && !s.fullTimeManager)) {
                                await addSuperstarsToManager(manager, superstarsToManage);
                                managersAdded.push({
                                    'managerName': manager.name,
                                    'managedSuperstarsNames': superstarsToManage.map(x => x.name),
                                });

                                // Check manager requests
                                for (let x of superstarsToManage) {
                                    let requestData = {'talentId': x.$loki};
                                    await checkTalentRequestAction({
                                        company: company,
                                        requestType: 'be_managed',
                                        talent: x
                                    });
                                    await checkTalentRequestAction({
                                        company: company, requestType: 'manage_x', talent: manager,
                                        data: requestData
                                    });
                                }
                            }
                        }
                    }
                }
            }

            // Add company log and special finishes data
            if (matchFinish.category === 'special') {
                let newLog = CompanyLog(month, realYear);
                newLog.text = `${matchFinish.name} Finish between ${commaSeparate(matchParticipants.map(x => x.name))}`;
                newLog.type = 'moment';
                newLog.realYear = year;
                newLog.eventName = event.name;
                newLog.value = 6;
                await CompanyLogs.insert(newLog);
                await addCompanyCompanyLogs(company, [newLog]);

                // Set months to re-use if not sandbox mode
                if (!company.userControlled || !game.settings['no_special_items_cooldown']) {
                    if (!company.specialFinishesData[matchFinish.name]) {
                        company.specialFinishesData[matchFinish.name] = {'months_to_reuse': 6};
                    } else {
                        company.specialFinishesData[matchFinish.name]['months_to_reuse'] = 6;
                    }
                }
            }

            // Add interfering member's graphic to match graphics
            const refereeSuperstar = await getMatchRefereeSuperstar(match, rosterSuperstars);
            if (matchFinish['interference'] && interferingMember && graphics) {
                let interferingSuperstars;
                if (interferingMember.objectName === 'faction') {
                    // Get available faction members not present in match
                    interferingSuperstars = (await getFactionSuperstars(interferingMember))
                        .filter(y => checkSuperstarSegmentAvailability(y)
                            && checkSuperstarBrandAvailability(event, y,
                                getSuperstarChampionshipsFromCompanyChampionships(y, companyChampionships)))
                } else {
                    interferingSuperstars = await getRosterMemberSuperstars(interferingMember);
                }
                interferingSuperstars = interferingSuperstars.filter(x => !objectInArray(x, matchSuperstars));
                for (const x of interferingSuperstars) {
                    // Don't add match manager or referee superstar's graphic
                    if (!objectInArray(x, matchManagers) && (!refereeSuperstar || x.$loki !== refereeSuperstar.$loki)) {
                        let interferingSuperstarGraphic = getGraphicForSuperstar(x);
                        graphics.push(interferingSuperstarGraphic);
                    }
                }
                updateGraphics = true;
            }
        }

        // Get event hype boosts
        if (hotMatch && company.userControlled && game.marketSize !== null) {
            const eventHypeBoostData = {};
            eventHypeBoostData['hypeBoost'] = 10;
            eventHypeBoostData['hotMatchBoost'] = true;
            event.hype += eventHypeBoostData['hypeBoost'];
            data['eventHype'] = event.hype;
            data['eventHypeBoostData'] = eventHypeBoostData;
        }

        // Add kayfabe points change
        for (const p of matchParticipants) {
            let kayfabePointsChange = 0;
            const win = p.$loki === winnerParticipant.$loki;
            kayfabePointsChange += await getKayfabePointsChange({
                changeType: `matchResult`,
                participants: matchParticipants,
                winner: winnerParticipant,
                win: win,
                weeklyShow: weeklyShow,
                match: match
            });
            if (mainEvent) {
                kayfabePointsChange += await getKayfabePointsChange({changeType: `mainEvent`, weeklyShow: weeklyShow});
            }
            if (win) {
                kayfabePointsChange += await getKayfabePointsChange({
                    changeType: `championships`,
                    wonChampionships: winnerData['wonChampionships'],
                    defendedChampionships: winnerData['defendedChampionships']
                });
            }
            if (kayfabePointsChange) {
                for (const s of p.tempSuperstars) {
                    updateSuperstarKayfabePoints(s, Math.floor(kayfabePointsChange / p.tempSuperstars.length));
                }
            }
        }

        // Get fatigue change if not disabled, update fatigue, add to results
        if (game.settings['enable_fatigue'] !== false) {
            for (let p of matchParticipants) {
                let participantFatigueChange = 0;
                for (let s of p.tempSuperstars) {
                    let superstarFatigueChange = getSuperstarFatigueChangeForMatch(s, matchGimmick, matchParticipants,
                        weeklyShow, type, tournament);
                    updateSuperstarFatigue(s, superstarFatigueChange);
                    participantFatigueChange += superstarFatigueChange;
                }
                // Get average fatigue change for participant, add to participant's data
                participantFatigueChange = Math.floor(participantFatigueChange / p.tempSuperstars.length);
                let participantData;
                if (p.$loki === winnerData['uid']) {
                    participantData = winnerData;
                } else {
                    participantData = losersData.find(x => x['uid'] === p.$loki);
                }
                participantData['fatigueChange'] = participantFatigueChange;
            }
        }

        // Mark ready to return as false
        for (const x of [...matchSuperstars, ...matchManagers]) {
            if (x.readyToReturn) {
                x.readyToReturn = false;
            }
        }

        // Mark hidden as false
        if (match.hidden) {
            match.hidden = false;
        }

        // Get data to return
        data['winner'] = winnerData;
        data['losers'] = losersData;
        data['rating'] = rating;
        data['ratingData'] = ratingData;
        data['feuds'] = feuds;
        data['feudItemsLevelData'] = feudItemsLevelData;
        data['unlockedFeudItems'] = unlockedFeudItems;
        data['championshipPrestiges'] = championshipPrestiges;
        data['finishName'] = match.finishName;
        data['finishText'] = match.finishText;
        data['matchFinish'] = matchFinish;
        data['factionReputationsData'] = factionReputationsData;
        data['factionReputationsData'].push(...winnerData['factionReputationsData']);  // Rep change for championships
        data['unavailable'] = unavailable;
        data['hairRemoved'] = hairRemoved;
        data['hairAdded'] = hairAdded;
        data['maskRemoved'] = maskRemoved;
        data['vacated'] = vacated;
        data['generatedText'] = generatedText;
        data['cashinData'] = cashinData;
        data['holyShitData'] = holyShitData;
        data['points'] = company.points;
        data['fans'] = company.fans;
        data['eventHype'] = event.hype;
        data['streaks'] = streaks;
        data['feudPotentials'] = feudPotentials;
        data['feudHypeIncreased'] = feudHypeIncreased;
        data['feudsStarted'] = feudsStarted;
        data['turnedHeel'] = turnedHeel;
        data['turnedFace'] = turnedFace;
        data['debutedGimmicks'] = debutedGimmicks;
        data['hotMatch'] = hotMatch;
        data['overnessChanges'] = overnessChanges;
        data['staffSkillIncreases'] = staffSkillIncreases;
        data['gimmickEffectivenessLevelChanges'] = gimmickEffectivenessLevelChanges;
        data['managersRemoved'] = managersRemoved;
        data['managersAdded'] = managersAdded;
        data['hotFeuds'] = hotFeuds;
        data['unlockedChampionshipSegmentItems'] = unlockedChampionshipSegmentItems;
        data['bloodySuperstarsData'] = bloodySuperstarsData;
        data['factionConsequences'] = factionConsequences;
        data['fotcChanges'] = fotcChanges;
        data['unlockedGimmickMatches'] = unlockedGimmickMatches;
        if (gimmickMatchLevelData) {
            data['gimmickMatchLevelData'] = gimmickMatchLevelData
        }
        if (updateGraphics) {
            data['graphics'] = graphics
        }

        // Delete tempSuperstars attribute
        for (const x of matchParticipants) {
            delete x.tempSuperstars;
        }

        // Get tournament matches if next round
        if (match.tournamentRound && match.tournamentRound !== tournament.rounds && !simulator) {
            if (newTournamentRound) {
                // Get matches and segments data
                let eventMatchesData = await getEventMatchesData({
                    event: event, getChampionshipsAvailable: false, play: true,
                    rosterSuperstars: rosterSuperstars, game: game
                });
                let eventSegmentsData = await getEventSegmentsData({
                    event: event,
                    play: true,
                    rosterSuperstars: rosterSuperstars
                });
                let matchesAndSegmentsData = eventMatchesData.concat(eventSegmentsData);
                matchesAndSegmentsData.sort((a, b) => b.order - a.order);
                matchesAndSegmentsData = matchesAndSegmentsData.filter(x => x['segmentType'] === 'segment' ?
                    x['rating'] === null : x['winnerName'] === null);
                data['matches'] = matchesAndSegmentsData;
            }
            data['tournamentDisplay'] = await getTournamentDisplayData(tournament, game);
        }

        // Get cash in created match's data
        if (newMatch) {
            data['createdMatch'] = await getMatchData({
                match: newMatch, play: true,
                companyChampionships: companyChampionships, rosterSuperstars: rosterSuperstars, game: game
            });
        }

        async function awardOrUnlockPowerup(allPowerups, unlock = false) {
            let unlockedOrAwardedPowerup;
            let dataKey;
            if (unlock) {
                dataKey = 'unlockedPowerup';
            } else {
                allPowerups = allPowerups.filter(y => y.unlocked);
                dataKey = 'awardedPowerup';
            }
            unlockedOrAwardedPowerup = awardPowerup(allPowerups, unlock);
            data[dataKey] = {
                'name': unlockedOrAwardedPowerup.name, 'level': unlockedOrAwardedPowerup.level,
                'storyName': unlockedOrAwardedPowerup.storyName
            };
            if (company.userControlled) {
                let newMessage = await createPowerupMessage(unlockedOrAwardedPowerup, month, year, unlock);
                await addCompanyMessages(company, [newMessage]);
            }
        }

        async function processMatchParticipantWorkrateXp(p, xpToAdd) {
            const talentCompany = await getTalentCompany(p);
            const pSuperstars = await getRosterMemberSuperstars(p);
            let participantXpGained = 0;

            for (const s of pSuperstars) {
                // Check for skill xp multiplier trait
                let traitMultiplier = 1;
                for (const trait of s.traits) {
                    const traitData = traitsData[trait];
                    if (traitData && traitData['skill_xp_multiplier']) {
                        traitMultiplier = traitData['skill_xp_multiplier'];
                    }
                }

                // Get and add workrate xp
                const ageMultiplier = getTalentAgeMultiplier(s);
                const superstarXpGained = Math.round(xpToAdd * ageMultiplier * traitMultiplier);
                s.workrateXp += superstarXpGained;
                participantXpGained += superstarXpGained;

                // Add workrate xp, check level increase
                const increaseData = await updateSuperstarWorkrate(s, talentCompany, staffMembers, month, year);
                if (increaseData) {
                    data['workrateIncreases'].push({name: s.name, level: s.workrate});
                }
            }
            participantXpGained = Math.floor(participantXpGained / pSuperstars.length);

            // Add xp gained to winner/losers data
            if (p.$loki === winnerData['uid']) {
                winnerData['xpGained'] = participantXpGained;
            } else {
                const loserData = losersData.find(x => x['uid'] === p.$loki);
                if (loserData) {
                    loserData['xpGained'] = participantXpGained;
                }
            }
        }

        async function updateSuperstarGimmickEffectiveness(s, p) {
            // Find gimmick
            const superstarGimmick = await getSuperstarCurrentGimmick(s);
            if (superstarGimmick) {
                const isWinner = p.$loki === winnerData['uid'];

                // Get change
                const gimmickEffectivenessChange = getGimmickEffectivenessChange(s, rating, match.order, weeklyShow,
                    isWinner, 1, true, s.hot, matchFinish);
                if (gimmickEffectivenessChange !== 0) {
                    const gimmickData = progressGimmick(superstarGimmick, gimmickEffectivenessChange, s);

                    // Add gimmick effectiveness level change if present
                    if (gimmickData['overnessEffectChange']) {
                        gimmickEffectivenessLevelChanges.push(gimmickData);
                    }

                    // Add gimmick effectiveness change to participant's data
                    let participantData;
                    if (isWinner) {
                        participantData = winnerData;
                    } else {
                        participantData = losersData.find(x => x['uid'] === p.$loki);
                    }
                    participantData['gimmickEffectivenessChange'] += gimmickEffectivenessChange;

                    // Unlock special segment
                    if (superstarGimmick.character && superstarGimmick.character === 'Degenerate' &&
                        superstarGimmick.effectiveness >= 100) {
                        const talentCompany = await getTalentCompany(s);
                        if (talentCompany) {
                            await unlockSpecialSegment(talentCompany, 'Love Making', month, year);
                        }
                    }
                }

                // Remove gimmick change boost
                if (superstarGimmick.nextGimmickBoost) {
                    superstarGimmick.nextGimmickBoost = false;
                }
            }

            return superstarGimmick;
        }

        function updateOverness(p, increase) {
            p.overness += increase;
            p.overness = limitValueBetweenRange(p.overness, 0, 100);
            return p.overness;
        }

        return data;
    }
    catch (err) {
        // Delete tempSuperstars attribute
        for (const x of (await getMatchParticipants(match))) {
            delete x.tempSuperstars;
        }
        throw err;
    }
}

async function getMatchRating(participants, superstars, championships, gimmickMatch, match, weeklyShow, effect,
                              matchFinish, feuds, bloodBoost, fullTimeManagerFinish, annualTournament, storyName,
                              segmentsAndMatches) {  // get_rating_singles
    let data = {};
    let ranks = {'Main Eventer': 0.25, 'Jabroni': -0.25};
    let baseRatings = {1: 1.5, 2: 3.2, 3: 3.95, 4: 4.25};

    if (storyName === 'passion' && gimmickMatch && gimmickMatch.name === 'Femme Fatale' && !gimmickMatch.special) {
        data['rating'] = myround(getRandomInt(450, 525), 25) / 100;
        return data;
    }

    // Add average of workrate and rank bonus
    let rating = 0;
    for (const s of superstars) {
        rating += baseRatings[getSuperstarWorkrate(s)] || 3.2;
        rating += ranks[getRankFromPopularity(s.popularity)] || 0;
        // Get tag match workrate boost trait
        if (match.type === 'tag') {
            for (const trait of s.traits) {
                let traitData = traitsData[trait];
                if (traitData && traitData['tag_match_workrate_boost']) {
                    rating += traitData['tag_match_workrate_boost']
                }
            }
        }
    }

    // Add bonus for higher workrate participant again
    for (const x of participants) {
        const s = await getRosterMemberSuperstars(x);
        x.tempWorkrate = s.map(y => getSuperstarWorkrate(y)).reduce((partialSum, a) => partialSum + a, 0);
    }
    let topParticipant = getArrayMaxByProperty(participants, 'tempWorkrate');
    let topParticipantSuperstars = await getRosterMemberSuperstars(topParticipant);
    for (const s of topParticipantSuperstars) {
        rating += baseRatings[getSuperstarWorkrate(s)] || 3.2;
        rating += ranks[getRankFromPopularity(s.popularity)] || 0;
    }
    rating /= superstars.length + topParticipantSuperstars.length;

    // Add deviation
    let randomDeviations = null;
    if (effect === 'positive_boost') {
        randomDeviations = [0.3, 0.6]
    } else if (effect === 'negative_boost') {
        randomDeviations = [-0.3, -0.6]
    }
    if (randomDeviations) {
        rating += getRandomUniform(randomDeviations[0], randomDeviations[1])
    }

    // Add random boost/penalty
    let randomBoosts = [[-0.75, 2], [-0.5, 4], [-0.25, 18],
        [0, 52],
        [0.25, 18], [0.5, 4], [0.75, 2]];

    // Get multiplier for random boosts/penalties
    for (const superstar of superstars) {
        for (const trait of superstar.traits) {
            const traitData = traitsData[trait];
            // Add multiplier as fraction of superstars
            if (traitData && traitData['positive_match_rating_boost_multiplier']) {
                randomBoosts = randomBoosts.map(boost =>
                    boost[0] > 0.25 ?
                        [boost[0], boost[1] * traitData['positive_match_rating_boost_multiplier'] / superstars.length] :
                        [boost[0], boost[1]]  // Affect boosts/penalties with names
                );
            }
            if (traitData && traitData['negative_match_rating_boost_multiplier']) {
                randomBoosts = randomBoosts.map(boost =>
                    boost[0] < -0.25 ?
                        [boost[0], boost[1] * traitData['negative_match_rating_boost_multiplier'] / superstars.length] :
                        [boost[0], boost[1]]
                );
            }
        }
    }

    const randomBoost = weightedChoice(randomBoosts);
    rating += randomBoost;

    const matchNegativeBoosts = ['Indifferent Crowd', 'Worked Against Crowd', 'Bad Conditioning', 'Focused On Shortcomings',
        'Lack Of Psychology', 'No Story', 'Stop & Start Action', 'Slow Start', 'Sloppy Performances',
        'Boring Spots', 'Low Intensity'];

    const matchPositiveBoosts = ['Crowd Interest', 'Worked With Crowd', 'Great Form', 'Worked To Strengths',
        'Good Psychology', 'Interesting Story', 'Full Of Action', 'Lively Start',
        'Smooth Performances', 'Cool Spots', 'Plenty Of Intensity'];

    // Add random effect name if not squash finish
    if (!matchFinish || (matchFinish && matchFinish['name'] !== 'Squash')) {
        if (randomBoost < -0.25) {
            data['negativeBoostName'] = getRandomChoice(matchNegativeBoosts);
            data['negativeBoostNumber'] = randomBoost;
        } else if (randomBoost > 0.25) {
            data['positiveBoostName'] = getRandomChoice(matchPositiveBoosts);
            data['positiveBoostNumber'] = randomBoost;
        }
    }

    // Add championship boost
    let championshipBoost = 0;
    for (const championship of championships) {
        championshipBoost += getChampionshipBoost(championship.prestige);
    }
    if (championshipBoost > 0.25) {
        championshipBoost = 0.25;
    }
    rating += championshipBoost;

    // Add gimmick boost
    let gimmickBoost = 0;
    if (gimmickMatch) {
        const ratingBoosts = {1: 0.1, 2: 0.2, 3: 0.3};

        if (getRandomInt(0, 100) <= 70) {
            let ratingBoost = 0;
            if (gimmickMatch.ratingBoost < 1.13) {
                ratingBoost = 1;
            } else if (gimmickMatch.ratingBoost < 1.2) {
                ratingBoost = 2;
            } else {
                ratingBoost = 3;
            }

            gimmickBoost = ratingBoosts[ratingBoost];

            // Get trait multiplier for all superstars
            let traitGimmickMatchMultipliers = 0;
            for (const superstar of superstars) {
                for (const trait of superstar.traits) {
                    let traitData = traitsData[trait];
                    // Get gimmick match expert trait data
                    if (trait.includes('Match Expert') && gimmickMatch.name === trait.split(' Match Expert')[0]) {
                        traitData = traitsData['Match Expert'];
                    }
                    if (traitData && traitData['gimmick_match_multiplier']) {
                        traitGimmickMatchMultipliers += traitData['gimmick_match_multiplier'];
                    }
                }
            }

            // Add multiplier
            if (traitGimmickMatchMultipliers) {
                gimmickBoost *= traitGimmickMatchMultipliers;
            }

            // Set min/max values
            if (gimmickBoost > 1.0) {
                gimmickBoost = 1.0;
            }
            if (gimmickBoost < -1.0) {
                gimmickBoost = -1.0;
            }
        }
    }
    rating += gimmickBoost;

    // Weekly show penalty
    if (weeklyShow && !annualTournament) {
        rating += getRandomChoice([-0.5, -0.25]);
    }

    // Get multiplier for weekly show or monthly event match rating boost
    let eventTypeRatingBoost = 0;
    for (const superstar of superstars) {
        for (const trait of superstar.traits) {
            const traitData = traitsData[trait];
            if (weeklyShow) {
                if (traitData && traitData['weekly_show_match_rating_boost']) {
                    eventTypeRatingBoost += traitData['weekly_show_match_rating_boost'];
                }
            } else {
                if (traitData && traitData['monthly_event_match_rating_boost']) {
                    eventTypeRatingBoost += traitData['monthly_event_match_rating_boost'];
                }
            }
        }
    }
    eventTypeRatingBoost = limitValueBetweenRange(eventTypeRatingBoost, -0.8, 0.4);
    rating += eventTypeRatingBoost;

    // If any unhappy worker, lower rating by their part of the total workers
    const unhappySuperstars = superstars.filter(x => x.unhappy);
    if (unhappySuperstars.length > 0) {
        const unhappySuperstarsPenalty = 1.0 * unhappySuperstars.length / superstars.length;
        rating -= unhappySuperstarsPenalty;
        data['unhappySuperstarsPenalty'] = unhappySuperstarsPenalty;
    }

    // Add injury penalty
    const injuredSuperstars = superstars.filter(x => x.workableInjury || x.injured > 0);
    if (injuredSuperstars.length > 0) {
        const injuredSuperstarsPenalty = 1.5 * injuredSuperstars.length / superstars.length;
        rating -= injuredSuperstarsPenalty;
        data['workableInjuryPenalty'] = injuredSuperstarsPenalty;
    }

    // Add match finish penalty
    if (matchFinish) {
        const matchFinishAlreadyHeld = await checkMatchFinishAlreadyHeld(matchFinish, match, feuds, segmentsAndMatches);
        const matchFinishRatingEffects = getMatchFinishRatingEffect(matchFinish, gimmickMatch, feuds,
            matchFinishAlreadyHeld, fullTimeManagerFinish);
        rating += matchFinishRatingEffects['totalRatingEffect'];
        data['matchFinishRatingData'] = matchFinishRatingEffects['ratingEffects'];
    }

    // Add blood boost
    if (bloodBoost) {
        rating += bloodBoost;
        data['drewBloodBoost'] = bloodBoost;
    }

    // Add match bonuses
    const matchContractBonus = limitValueBetweenRange(match.contractBonus / 100.0, 0, 1);
    const streakBonus = limitValueBetweenRange(match.streakBonus / 100.0, 0, 1);
    const eventBonus = limitValueBetweenRange(match.eventBonus / 100.0, 0, 1);
    const tournamentFinalBonus = limitValueBetweenRange(match.tournamentFinalBonus / 100.0, 0, 1);
    rating += streakBonus + eventBonus + tournamentFinalBonus + matchContractBonus;

    // Format
    if (rating < 0) {
        rating = 0;
    }
    data['rating'] = myround(rating);

    // Delete tempWorkrate attribute
    for (const x of participants) {
        delete x.tempWorkrate;
    }

    return data;
}

function getMatchFinishRatingEffect(matchFinish, matchGimmick, matchFeuds, matchFinishAlreadyHeld,
                                    fullTimeManagerFinish = false) {  // get_match_finish_rating_effect
    const data = {};
    data['ratingEffects'] = [];
    let totalRatingEffect = 0;

    // Get rating effect
    const matchFinishRatingEffect = matchFinish['ratingEffect'];

    // Chance to remove negative rating effect if full time manager part of dusty finish
    let addRatingEffect = true;
    if (fullTimeManagerFinish && matchFinish['category'] === 'dusty' && matchFinish['ratingEffect'] < 0 &&
        getRandomInt(0, 100) <= 60) {
        addRatingEffect = false;
    }
    if (addRatingEffect) {
        data['ratingEffects'].push({
            name: matchFinish['name'],
            number: matchFinishRatingEffect
        });
        totalRatingEffect += matchFinishRatingEffect;
    }

    // Get penalty for use in feud blowoff
    if (!matchFinish['changeChampionship']) {
        if (matchFeuds.some(x => x.runBlowoff)) {
            const blowoffPenalty = -0.75;
            data['ratingEffects'].push({
                name: 'Unsatisfying Blowoff',
                number: blowoffPenalty
            });
            totalRatingEffect += blowoffPenalty;
        }
    }

    // Get penalty for match finish already held
    if (matchFinishAlreadyHeld) {
        const alreadyHeldPenalty = -0.5;
        data['ratingEffects'].push({
            name: 'Finish Already Held',
            number: alreadyHeldPenalty
        });
        totalRatingEffect += alreadyHeldPenalty;
    }

    data['totalRatingEffect'] = totalRatingEffect;

    return data;
}

async function checkMatchFinishAlreadyHeld(matchFinish, match, feuds, eventMatches) {  // check_match_finish_already_held
    let matchFinishAlreadyHeld = isMatchFinishPresent(matchFinish, match, eventMatches);
    if (!matchFinishAlreadyHeld) {
        const feudMatches = (await Promise.all(feuds.map(x => getFeudMatches(x)))).flat();
        matchFinishAlreadyHeld = isMatchFinishPresent(matchFinish, match, feudMatches);
    }
    return matchFinishAlreadyHeld;
}

function isMatchFinishPresent(matchFinish, match, matches) {  // is_match_finish_present
    return matches.some(x => x.$loki !== match.$loki && x.rating && x.finishName === matchFinish['name']);
}

function getChampionshipBoost(prestige) {  // get_championship_boost
    const boosts = {'S': 0.25, 'A': 0.2, 'B': 0.15, 'C': 0.1};
    return boosts[prestige] || 0.1;
}

async function processMatchWinnerAndLosers(winnerParticipant, loserParticipants, championships, gimmickMatch, company,
                                           match, streakEnded, tournamentFinal, lowerPopularityChange, weeklyShow,
                                           hotMatch, matchFinish, rosterSuperstars) {
    // Declare variables
    const winnerData = {};
    const losersData = [];
    const defendedChampionships = [];
    const wonChampionships = [];
    const retainedChampionships = [];
    const factionReputationsData = [];
    const changeChampionship = !matchFinish || matchFinish['changeChampionship'];
    const winnerSuperstars = winnerParticipant.tempSuperstars;
    let activeEffectIncrease = 1;
    let activeEffectDecrease = 1;
    let matchFinishWinMultiplier = 1;
    let matchFinishLossMultiplier = 1;
    let gimmickMatchIncrease = 1;
    let gimmickMatchDecrease = 1;
    let hotMatchIncrease = 1;
    let hotMatchDecrease = 1;
    let streakEndedIncrease = 1;
    let streakEndedDecrease = 1;
    let tournamentWinIncrease = 1;
    let popularityMultiplier = 1;

    // Get temp popularities
    const matchParticipants = [winnerParticipant, ...loserParticipants];
    for (const x of matchParticipants) {
        x.tempStartPopularity = await getRosterMemberPopularity(x);
    }

    // Get multipliers
    if (gimmickMatch) {
        gimmickMatchIncrease = gimmickMatch.popularityIncrease;
        gimmickMatchDecrease = gimmickMatch.popularityDecrease;
        if (winnerParticipant.tempSuperstars.every(x => x.partTimer)) {
            gimmickMatchIncrease *= 0.5;
            gimmickMatchDecrease *= 0.5;
        }
    }
    if (hotMatch) {
        hotMatchIncrease = 1.4;
        hotMatchDecrease = -0.5;
    }
    if (streakEnded) {
        [streakEndedIncrease, streakEndedDecrease] = getStreakEndedBoosts(streakEnded.length);
    }
    if (tournamentFinal) {
        tournamentWinIncrease = getTournamentWinBonus(tournamentFinal);
    }
    if (lowerPopularityChange) {
        popularityMultiplier = 0.4;
    }
    if (matchFinish) {
        matchFinishWinMultiplier = matchFinish.winMultiplier;
        matchFinishLossMultiplier = matchFinish.lossMultiplier;
    }

    // Process championships
    let championshipMatchLostChange = 0;
    let championshipMatchWonChange = 0;
    for (const championship of championships) {
        // Championship defense
        const winnerSuperstarsChampionships = (await Promise.all(winnerSuperstars.map(x => getSuperstarChampionships(x)))).flat();
        if (objectInArray(championship, winnerSuperstarsChampionships)) {
            defendedChampionships.push(getChampionshipMatchData(championship));
            championshipMatchWonChange += getChampionshipPopularityIncrease(championship, true);
            championshipMatchLostChange += getChampionshipPopularityDecrease(championship, true);
        }
        // Vacant championship win
        else if (championship.vacated) {
            if (changeChampionship) {
                let championshipsSet = (championship.tagTeam || championship.trio) ? (await getCompanyChampionships(company))
                    .filter(x => checkAreChampionshipsEqual(x, championship)) : [championship];

                // Add championship(s) to winner superstars
                for (const [i, c] of championshipsSet.entries()) {
                    const s = winnerSuperstars[i];
                    await addSuperstarChampionships(s, [c]);
                    c.vacated = false;

                    // Update morale for championship win
                    const moraleChange = await getSuperstarMoraleChange({changeType: 'championship_result', positive: true,
                        championship: c});
                    updateSuperstarMorale(s, moraleChange);

                    // Update faction rep (championship won)
                    const superstarFactionsData = await processFactionXpChangeForSuperstar({superstar: s, championshipWon: c});
                    factionReputationsData.push(...superstarFactionsData);

                    // Check talent request
                    await checkTalentRequestAction({company: company, requestType: 'win_a_championship', talent: s});
                }

                wonChampionships.push(getChampionshipMatchData(championship));
                championshipMatchWonChange += getChampionshipPopularityIncrease(championship);
            } else {
                retainedChampionships.push(getChampionshipMatchData(championship));
            }
        }
        // Championship win
        else {
            if (changeChampionship) {
                let championshipsSet = (championship.tagTeam || championship.trio) ? (await getCompanyChampionships(company))
                    .filter(x => checkAreChampionshipsEqual(x, championship)) : [championship];

                // Add championship(s) to winner superstars
                for (const [i, c] of championshipsSet.entries()) {
                    const previousChampion = await getChampionshipSuperstar(c);
                    const s = winnerSuperstars[i];
                    await removeSuperstarChampionships(previousChampion, [c]);
                    await addSuperstarChampionships(s, [c]);

                    // Update morale for championship win/loss
                    let moraleChange = await getSuperstarMoraleChange({changeType: 'championship_result', positive: true,
                        championship: c});
                    updateSuperstarMorale(s, moraleChange);
                    moraleChange = await getSuperstarMoraleChange({changeType: 'championship_result', positive: false,
                        championship: c});
                    updateSuperstarMorale(previousChampion, moraleChange);

                    // Update faction rep (championship won/lost)
                    let superstarFactionsData = await processFactionXpChangeForSuperstar({superstar: s, championshipWon: c});
                    factionReputationsData.push(...superstarFactionsData);
                    superstarFactionsData = await processFactionXpChangeForSuperstar({superstar: previousChampion,
                        championshipLost: c});
                    factionReputationsData.push(...superstarFactionsData);

                    // Check talent request
                    await checkTalentRequestAction({company: company, requestType: 'win_a_championship', talent: s});
                    let requestData = {'championshipId': c.$loki};
                    await checkTalentRequestAction({company: company, requestType: 'lose_championship', talent: previousChampion,
                        data: requestData});
                    await checkTalentRequestAction({company: company, requestType: 'vacate_championship', talent: previousChampion,
                        data: requestData, failRequest: true});
                }

                wonChampionships.push(getChampionshipMatchData(championship));
                championshipMatchWonChange += getChampionshipPopularityIncrease(championship);
                championshipMatchLostChange += getChampionshipPopularityDecrease(championship);
            } else {
                retainedChampionships.push(getChampionshipMatchData(championship));
            }
        }
    }

    // Get popularity changes
    const topLoserParticipant = getArrayMaxByProperty(loserParticipants, 'tempStartPopularity');
    for (let x of matchParticipants) {
        for (let s of x.tempSuperstars) {
            let isWinner = x.$loki === winnerParticipant.$loki;
            let winOrLossMultiplier;
            let hotSuperstarMultiplier = 1;
            let handicapIncreaseMultiplier;

            // Get change
            let popularityChange;
            if (isWinner) {
                winOrLossMultiplier = getWinMultiplier(getRankFromPopularity(x.tempStartPopularity),
                    getRankFromPopularity(topLoserParticipant.tempStartPopularity));
                if (s.hot) {
                    hotSuperstarMultiplier = 1.3;
                }
                popularityChange = getMatchPopularityIncrease(winnerParticipant.tempStartPopularity, topLoserParticipant.tempStartPopularity,
                    winOrLossMultiplier, gimmickMatchIncrease, activeEffectIncrease, streakEndedIncrease, tournamentWinIncrease,
                    popularityMultiplier, match.hype, weeklyShow, hotMatchIncrease, hotSuperstarMultiplier, matchFinishWinMultiplier);
                handicapIncreaseMultiplier = 1.5;
            } else {
                winOrLossMultiplier = getLossMultiplier(getRankFromPopularity(x.tempStartPopularity),
                    getRankFromPopularity(winnerParticipant.tempStartPopularity));
                if (s.hot) {
                    hotSuperstarMultiplier = 1.4;
                }
                popularityChange = getMatchPopularityDecrease(x.tempStartPopularity, winnerParticipant.tempStartPopularity,
                    winOrLossMultiplier, gimmickMatchDecrease, activeEffectDecrease, streakEndedDecrease, popularityMultiplier,
                    weeklyShow, hotMatchDecrease, hotSuperstarMultiplier, matchFinishLossMultiplier);
                handicapIncreaseMultiplier = 1.25;
            }

            // Lower change for part timers
            if (s.partTimer) {
                popularityChange *= 0.7;
            }

            // Lower change for multi men match
            if (!isWinner && loserParticipants.length > 1) {
                popularityChange *= 0.6;
            }

            // Adjust change for handicap match
            if (loserParticipants[0].tempSuperstars.length < winnerSuperstars.length) {
                // Lower if more winners than losers
                popularityChange *= 0.5 / ((winnerSuperstars.length) - loserParticipants[0].tempSuperstars.length);
            } else if (loserParticipants[0].tempSuperstars.length > winnerSuperstars.length) {
                // Raise if more losers than winners
                popularityChange *= handicapIncreaseMultiplier;
            }

            // Add championship won/lost change
            if (isWinner) {
                popularityChange += championshipMatchWonChange;
            }
            else {
                popularityChange += championshipMatchLostChange;
            }

            // Reduce change for tag match
            if (match.type === 'tag') {
                popularityChange *= 0.5;
            }

            popularityChange = Math.round(popularityChange);

            // Update popularity
            if (isWinner) {
                updateSuperstarPopularity(s, popularityChange);
            }
            else {
                updateSuperstarPopularity(s, popularityChange, true, hotMatch);
            }
        }
    }

    // Update morale for winner
    let affectMorale = !matchFinish || matchFinish['affectMorale'];
    for (let s of winnerSuperstars) {
        // Check for affect morale trait
        let affectSuperstarMoraleChance = 100;
        for (let trait of s.traits) {
            let traitData = traitsData[trait];
            if (traitData && traitData['win_affects_morale_chance']) {
                affectSuperstarMoraleChance = traitData['win_affects_morale_chance'];
            }
        }

        // Update morale for match win
        if (affectMorale && getRandomInt(0, 100) <= affectSuperstarMoraleChance) {
            let winnerPopularityDifference = (await getRosterMemberPopularity(winnerParticipant)) -
                (await getRosterMemberPopularity(topLoserParticipant));
            let moraleChange = await getSuperstarMoraleChange({changeType: 'match_result', positive: true,
                popularityDifference: winnerPopularityDifference, matchParticipants: matchParticipants,
                weeklyShow: weeklyShow});
            updateSuperstarMorale(s, moraleChange);
        }
    }

    // Update morale for losers
    for (let x of loserParticipants) {
        for (let s of x.tempSuperstars) {
            // Check for no morale change trait
            let affectSuperstarMorale = affectMorale;
            let affectSuperstarMoraleChance = 100;
            for (let trait of s.traits) {
                let traitData = traitsData[trait];
                if (traitData && traitData['no_morale_change_rank']) {
                    if (getRankFromPopularity(winnerParticipant.tempStartPopularity) === traitData['no_morale_change_rank']) {
                        // Chance to not affect morale
                        if (getRandomInt(0, 100) <= 70) {
                            affectSuperstarMorale = false;
                        }
                    }
                }
                if (traitData && traitData['no_morale_change_except_rank']) {
                    if (getRankFromPopularity(winnerParticipant.tempStartPopularity) !== traitData['no_morale_change_except_rank']) {
                        if (getRandomInt(0, 100) <= 70) {
                            affectSuperstarMorale = false;
                        }
                    }
                }
                if (traitData && traitData['loss_affects_morale_chance']) {
                    affectSuperstarMoraleChance = traitData['loss_affects_morale_chance'];
                }
            }

            // Update morale for match loss
            if (affectSuperstarMorale && getRandomInt(0, 100) <= affectSuperstarMoraleChance && !match.tournamentRound) {
                let opponentPopularityDifference = (await getRosterMemberPopularity(x)) -
                    (await getRosterMemberPopularity(winnerParticipant));
                let moraleChange = await getSuperstarMoraleChange({changeType: 'match_result',
                    popularityDifference: opponentPopularityDifference, matchParticipants: matchParticipants,
                    weeklyShow: weeklyShow});
                updateSuperstarMorale(s, moraleChange);
            }

            // Update morale for championship match
            if (defendedChampionships.length > 0) {
                let moraleChange = await getSuperstarMoraleChange({changeType: 'championship_match', positive: true,
                        championship: defendedChampionships[0]});
                updateSuperstarMorale(s, moraleChange);
            }
        }
    }

    // Get overness changes
    let loserParticipant = getRandomChoice(loserParticipants);
    for (const x of [winnerParticipant, loserParticipant]) {
        let isWinner = x.$loki === winnerParticipant.$loki;
        const participantPopularity = await getRosterMemberPopularity(x);
        for (const s of x.tempSuperstars) {
            // Get overness change
            let overnessChange = 0;
            let overnessChangeTrait;
            let popularityChangeForOverness;
            if (isWinner) {
                popularityChangeForOverness = participantPopularity - x.tempStartPopularity;
                if (match.type === 'tag') {
                    popularityChangeForOverness *= 2
                }
                overnessChange = getMatchOvernessIncrease(x, popularityChangeForOverness, s.faceOfTheCompany);
                // Add annual tournament win boost
                if (tournamentFinal && tournamentFinal.annualTournament) {
                    overnessChange += 15
                }
                overnessChange = Math.ceil(overnessChange / x.tempSuperstars.length);
                overnessChangeTrait = 'overness_increase_multiplier';
            }
            else {
                popularityChangeForOverness = x.tempStartPopularity - participantPopularity;
                if (match.type === 'tag') {
                    popularityChangeForOverness *= 2
                }
                if (!hotMatch) {
                    overnessChange = getMatchOvernessDecrease(x, popularityChangeForOverness, s.faceOfTheCompany);
                }
                overnessChange = Math.floor(overnessChange / x.tempSuperstars.length);
                overnessChangeTrait = 'overness_decrease_multiplier';
            }

            // Get trait multiplier for overness change
            for (const trait of s.traits) {
                const traitData = traitsData[trait];
                if (traitData && traitData[overnessChangeTrait]) {
                    overnessChange *= traitData[overnessChangeTrait];
                }
            }

            // Change overness
            s.overness += Math.floor(overnessChange);
            s.overness = limitValueBetweenRange(s.overness, 0, 100);
        }
    }

    // Get data to return
    let winnerNewPopularity = await getRosterMemberPopularity(winnerParticipant);
    winnerData['uid'] = winnerParticipant.$loki;
    winnerData['name'] = winnerParticipant.name;
    winnerData['popularityChange'] = winnerNewPopularity - winnerParticipant.tempStartPopularity;
    winnerData['popularity'] = winnerNewPopularity;
    winnerData['wonChampionships'] = wonChampionships;
    winnerData['defendedChampionships'] = defendedChampionships;
    winnerData['retainedChampionships'] = retainedChampionships;
    winnerData['gimmickEffectivenessChange'] = 0;
    winnerData['factionReputationsData'] = factionReputationsData;
    winnerData['hot'] = winnerSuperstars.every(x => x.hot);
    winnerData['stale'] = winnerSuperstars.every(x => x.stale);
    winnerData['managersData'] = await getParticipantManagersData(winnerParticipant, match.managersUsed, rosterSuperstars);

    for (const x of loserParticipants) {
        const loserData = {};
        let loserNewPopularity = await getRosterMemberPopularity(x);
        loserData['uid'] = x.$loki;
        loserData['name'] = x.name;
        loserData['popularityChange'] = x.tempStartPopularity - loserNewPopularity;
        loserData['popularity'] = loserNewPopularity;
        loserData['gimmickEffectivenessChange'] = 0;
        loserData['hot'] = x.tempSuperstars.every(y => y.hot);
        loserData['stale'] = x.tempSuperstars.every(y => y.stale);
        loserData['managersData'] = await getParticipantManagersData(x, match.managersUsed, rosterSuperstars);
        losersData.push(loserData);
    }

    // Delete tempStartPopularity attributes
    for (const x of matchParticipants) {
        delete x.tempStartPopularity;
    }

    return [winnerData, losersData];
}

async function checkMatchHot(match, participants, superstars) {
    let chance = 1;

    // Minimum rating
    if (match.rating < 4) {
        return false;
    }

    // Match rating factor
    if (match.rating >= 4.75) {
        chance += 10;
    }

    // Match hype factor
    chance += match.hype / 5;

    // Hot/stale superstars factor
    let hotParticipantBonus = 0;
    for (const x of superstars) {
        if (x.hot) {
            hotParticipantBonus += 8 / superstars.length;
        } else if (x.stale) {
            hotParticipantBonus -= 8 / superstars.length;
        }
    }
    chance += hotParticipantBonus;

    // Get trait multiplier for hot match chance
    let traitBoost = 0;
    for (const superstar of superstars) {
        for (const trait of superstar.traits) {
            const traitData = traitsData[trait];
            if (traitData && traitData['hot_match_chance_boost']) {
                traitBoost += traitData['hot_match_chance_boost'];
            }
        }
    }
    traitBoost = limitValueBetweenRange(traitBoost, 0, 15);
    chance += traitBoost;

    // Max chance
    if (chance >= 50) {
        chance = 50;
    }

    if (getRandomInt(1, 100) <= chance) {
        match.hot = true;
        return true;
    }

    return false;
}

async function checkToAddFeud(feudItemName, feudParticipants, company, mainRoster, month, year) {
    let data = {};
    let feudItems = (await getCompanyFeudItems(company)).filter(y => y.unlocked &&
        y.requirement === feudItemName);
    let feudItem = getRandomChoice(feudItems);

    // Check for existing feud
    let existingFeud;
    for (const f of (await getRosterMemberFeuds(feudParticipants[0]))) {
        if ((f.started && !f.ended) || (!f.started && f.directFeudEvent && !f.ended)) {
            if ((await getFeudParticipants(f)).every(y => objectInArray(y, feudParticipants))) {
                existingFeud = f;
                break;
            }
        }
    }

    if (!existingFeud) {
        // Add potential feud
        let newFeud = Feud();
        newFeud.name = feudItem.name;
        newFeud.hype = feudItem.baseHype;
        newFeud.startMonth = month;
        newFeud.startYear = year;
        newFeud.directFeudEvent = feudItem.requirement;
        newFeud.participants = feudParticipants.map(y => y.name);
        await Feuds.insert(newFeud);
        await addFeudItemFeuds(feudItem, [newFeud]);
        await addRosterFeuds(mainRoster, [newFeud]);
        if (feudParticipants[0].objectName === 'superstar') {
            await addFeudSuperstars(newFeud, feudParticipants)
        } else if (feudParticipants[0].objectName === 'tagTeam') {
            await addFeudTagTeams(newFeud, feudParticipants)
        } else if (feudParticipants[0].objectName === 'faction') {
            await addFeudFactions(newFeud, feudParticipants)
        }
        data['key'] = 'feudPotentials';
        data['value'] = {
            'name': newFeud.name,
            'participants': feudParticipants.map(y => y.name)
        };
    } else {
        // Add hype to existing feud
        let hypeIncrease = Math.floor(feudItem.baseHype / 2);
        existingFeud.hype += hypeIncrease;
        data['key'] = 'feudHypeIncreased';
        data['value'] = {
            'name': existingFeud.name, 'participants': feudParticipants.map(y => y.name),
            'hypeIncrease': hypeIncrease, 'newFeud': feudItem.name
        };
    }

    return data;
}

function getDangerousWorkerSuperstar(opponentSuperstars) {  // get_dangerous_worker_superstar
    return opponentSuperstars.find(x => {
        for (const t of x.traits) {
            if (traitsData[t] && traitsData[t]['cause_injury_chance_multiplier']) {
                return true;
            }
        }
    })
}

function updateMatchOrSegmentGraphics(matchOrSegmentGraphics, s) {
    // Update superstar's graphic dict in matchOrSegmentGraphics. Add title, uid, blood to dict.
    const participantGraphic = matchOrSegmentGraphics.find(x => x && x['uid'] === s.$loki);
    const participantGraphicIndex = matchOrSegmentGraphics.indexOf(participantGraphic);
    if (participantGraphic) {
        const titleGraphic = participantGraphic['title'];
        const uidGraphic = participantGraphic['uid'];
        const bloodGraphic = participantGraphic['blood'];

        matchOrSegmentGraphics[participantGraphicIndex] = getGraphicForSuperstar(s);
        if (titleGraphic) {
            matchOrSegmentGraphics[participantGraphicIndex].title = titleGraphic;
        }
        matchOrSegmentGraphics[participantGraphicIndex].uid = uidGraphic;
        matchOrSegmentGraphics[participantGraphicIndex].blood = bloodGraphic;
    }
    return matchOrSegmentGraphics;
}

function checkGimmickMatchesToUnlock(gimmickMatch, gimmickMatches) {  // check_gimmick_match
    // Check for gimmick match unlocks, returning unlocked
    const unlocked = [];
    const toUnlockNames = gimmickMatchUnlocksData[gimmickMatch.name] || [];
    for (const toUnlockName of toUnlockNames) {
        const gimmickMatchToUnlock = gimmickMatches.find(x => x.name === toUnlockName);
        if (gimmickMatchToUnlock && !gimmickMatchToUnlock.available && gimmickMatch.level === 3) {
            gimmickMatchToUnlock.available = true;
            unlocked.push(gimmickMatchToUnlock.name);
        }
    }
    return unlocked;
}

function addPerkToGimmickMatch(gimmickMatch, perk = null) {  // add_perk_to_gimmick_match
    const perks = ['rating', 'injury', 'popularity', 'cost'];

    if (perk === null) {
        perk = getRandomChoice(perks)
    }

    if (perk === 'rating') {
        gimmickMatch.ratingBoost += gimmickMatch.level / 15.0;
    } else if (perk === 'injury') {
        gimmickMatch.injuryRate -= gimmickMatch.level / 23.0;
    } else if (perk === 'popularity') {
        gimmickMatch.popularityIncrease += gimmickMatch.level / 5.0;
        gimmickMatch.popularityDecrease -= gimmickMatch.level / 12.0;
    } else if (perk === 'cost') {
        const decrease = myround(gimmickMatch.level * 0.12 * gimmickMatch.cost, 5);
        gimmickMatch.cost -= decrease;
        if (gimmickMatch.cost < 5) {
            gimmickMatch.cost = 5;
        }
    }

    return perk;
}

function generateIronmanMatchText() {
    return getRandomChoice(["1-0", "2-1", "3-1", "4-1", "3-2", "4-2", "4-3", "5-4"]);
}

function generateEliminationMatchResult(winnerParticipant, participants) {
    const matchTexts = [];
    const participantsData = participants.map(p => ({'participant': p, 'superstars': [...p.tempSuperstars]}));
    const winnerParticipantData = participantsData.find(x => x['participant'].$loki === winnerParticipant.$loki);
    const showSurvivors = winnerParticipantData['superstars'].length > 1;

    function eliminateSuperstar() {
        // Get superstar to eliminate from participants, except last superstar of winner
        let p = getRandomChoice(participantsData);
        while (p === winnerParticipantData && p['superstars'].length < 2) {
            p = getRandomChoice(participantsData);
        }
        const superstarToEliminate = getRandomChoice(p['superstars']);

        // Remove superstar, remove participant if all superstars eliminated
        p['superstars'].splice(p['superstars'].indexOf(superstarToEliminate), 1);
        if (p['superstars'].length < 1) {
            participantsData.splice(participantsData.indexOf(p), 1);
        }

        // Get elimination text
        const eliminatedByParticipant = getRandomChoice(participantsData.filter(y => y !== p));
        const eliminatedBy = getRandomChoice(eliminatedByParticipant['superstars']);
        const text = `${eliminatedBy.name} eliminated ${superstarToEliminate.name}`;

        return [superstarToEliminate, text];
    }

    try {
        // Run eliminations until one participant remains
        while (participantsData.length > 1) {
            const [eliminatedSuperstar, text] = eliminateSuperstar();
            matchTexts.push(text);
        }
        // Show survivors if winner is not a single superstar
        if (showSurvivors) {
            const survivorNames = winnerParticipantData['superstars'].map(x => x.name);
            const survivorWord = survivorNames.length > 1 ? 'Survivors' : 'Survivor';
            const text = `${survivorWord}: ${commaSeparate(survivorNames)}`;
            matchTexts.push(text);
        }
    } catch (err) {
        captureError(err);
    }

    return matchTexts.join(' ... ');
}

function generateTwoOutOfThreeFallsResult(winnerParticipant, participants, fallGimmickNames = null) {  // generate_two_out_of_three_falls_result
    const matchTexts = [];

    try {
        // Select whether to run 2 or 3 falls
        const fallsToRun = weightedChoice([[3, 90], [2, 10]]);
        let fallWinner;
        for (let x of Array(fallsToRun).keys()) {
            if (fallsToRun === 3) {
                if (x === 0) {
                    // Choose random participant for first fall
                    fallWinner = getRandomChoice(participants)
                } else if (x === 1) {
                    // Choose other participant for second fall
                    fallWinner = participants.find(p => p.$loki !== fallWinner.$loki);
                } else if (x === 2) {
                    // Choose winner for final fall
                    fallWinner = winnerParticipant;
                }
            } else {
                // Choose winner for all falls if 2 falls
                fallWinner = winnerParticipant;
            }

            // Get fall and gimmick text
            const fallNumber = x + 1;
            const fallNumberText = {1: "st", 2: "nd", 3: "rd"}[fallNumber];
            const gimmickText = fallGimmickNames && fallGimmickNames[x] ? ` (${fallGimmickNames[x]} Match)` : "";

            // Get fall text
            const fallText = `${fallWinner.name} won the ${fallNumber}${fallNumberText} fall${gimmickText}`;
            matchTexts.push(fallText);
        }
    } catch (error) {
        captureError(error)
    }

    return matchTexts.join(" ... ");
}

async function generateBattleRoyalMatchResult(match, winnerParticipant, matchType, allParticipants, allSuperstars) {  // generate_battle_royal_result
    // Declare variables
    let data = [];
    let entryData = {};
    let inMatch = [];
    let eliminated = [];
    let finalFourDisplayed = false;
    let loserParticipants = allParticipants.filter(x => x.$loki !== winnerParticipant.$loki);
    let loserSuperstars = loserParticipants.flatMap(x => x.tempSuperstars);

    // Helper function to eliminate superstar
    async function eliminateSuperstar(matchSuperstars) {
        // Choose who is eliminated from loser superstars
        let choices = matchSuperstars.filter(x => objectInArray(x, loserSuperstars));
        let s = getRandomChoice(choices);
        matchSuperstars.splice(matchSuperstars.indexOf(s), 1);
        const text = `${getRandomChoice(matchSuperstars).name} eliminated ${s.name} (${entryData[s.$loki]})`;
        return [s, text];
    }

    function getParticipantFromId(id) {
        return allSuperstars.find(x => x.$loki === parseInt(id));
    }

    // Get entry numbers, final number
    let entryNumbers = range(allSuperstars.length, 1);
    let finalNumber;
    if (matchType === 'singles') {
        finalNumber = 1;
    } else {
        if (winnerParticipant.trio) {
            finalNumber = 3;
        } else {
            finalNumber = 2;
        }
    }

    // Randomize entries and assign to superstars
    shuffle(entryNumbers);
    for (const x of allSuperstars) {
        entryData[x.$loki] = entryNumbers.pop();
    }

    // Sort by entry order
    const sortedEntryData = Object.entries(entryData).sort((a, b) => a[1] - b[1]);

    // First two entries to start the match
    for (const [participantId, entryNumber] of sortedEntryData.slice(0, 2)) {
        const participant = getParticipantFromId(participantId);
        inMatch.push(participant);
        data.push(`${participant.name} entered at No ${entryNumber}.`);
    }

    // Enter the rest of the superstars
    for (const [participantId, entryNumber] of sortedEntryData.slice(2)) {
        const participant = getParticipantFromId(participantId);
        inMatch.push(participant);
        data.push(`${participant.name} entered at No ${entryNumber}.`);

        // Eliminate a participant or continue to next entry
        let pick = Math.random();
        while (pick < 0.4 && inMatch.length > finalNumber) { // More than team size at a time to prevent all participants
            // being in the same winning team, bugging eliminateSuperstar

            // Eliminate
            const [eliminatedSuperstar, text] = await eliminateSuperstar(inMatch);
            eliminated.push(eliminatedSuperstar);
            data.push(text);
            pick = Math.random();

            // Display final four
            if (inMatch.length === 4 && eliminated.length === allSuperstars.length - 4 && !finalFourDisplayed) {
                data.push(`Final Four: ${inMatch.map(x => x.name).join(", ")}.`);
                finalFourDisplayed = true;
            }
        }
    }

    // Once all superstars have entered
    while (inMatch.length > finalNumber) {
        // Eliminate
        const [eliminatedSuperstar, text] = await eliminateSuperstar(inMatch);
        eliminated.push(eliminatedSuperstar);
        data.push(text);

        // Display final four
        if (inMatch.length === 4 && !finalFourDisplayed) {
            data.push(`Final Four: ${inMatch.map(x => x.name).join(", ")}.`);
            finalFourDisplayed = true;
        }
    }

    // Format text
    const text = [];
    let winnerTexts = 0;
    for (let [index, item] of data.entries()) {
        let addedEllipses = false;
        if (index === data.length - 5 || [8, 24, 44].includes(index)) {
            addedEllipses = true;
            text.push("...");
        }

        // Add winner texts
        if (item.includes(winnerParticipant.name) && winnerTexts < 7) {
            if (2 < index && index < data.length - 5 && !addedEllipses) {
                text.push("...");
            }
            text.push(item);
            winnerTexts += 1;
        } else if (index < 2 || (7 < index && index < 10) || (23 < index && index < 26) || (43 < index && index < 46) ||
            index >= data.length - 5) {
            text.push(item);
        } else if (item.includes("No 30")) {
            if (!addedEllipses) {
                text.push("...");
            }
            text.push(item);
        }
    }

    return text.join(' ');
}

function updateTournamentPrestige(tournament) {  // update_tournament_prestige
    let prestigeIncrease = false;
    let prestigeDecrease = false;

    if (tournament.xp >= 110 && tournament.prestige !== 'A') {
        tournament.prestige = 'A';
        tournament.cost += 50;
        prestigeIncrease = true;
    } else if (40 <= tournament.xp && tournament.xp < 110 && tournament.prestige !== 'B') {
        if (tournament.prestige === 'A') {
            tournament.cost -= 50;
            prestigeDecrease = true;
        } else {
            tournament.cost += 50;
            prestigeIncrease = true;
        }
        tournament.prestige = 'B';
    } else if (tournament.xp < 40 && tournament.prestige !== 'C') {
        tournament.prestige = 'C';
        tournament.cost -= 50;
        prestigeDecrease = true;
    }

    return [prestigeIncrease, prestigeDecrease];
}

async function getTournamentXpChange(tournament) {  // get_xp_change
    let xpChange;
    const tournamentRating = await getTournamentRating(tournament);

    if (tournamentRating < 3.5) {
        xpChange = (4 - tournamentRating) * -10;
    } else if (tournamentRating < 5) {
        xpChange = (3 - tournamentRating) * -15;
    } else {
        xpChange = (2.5 - tournamentRating) * -15;
    }
    return Math.floor(xpChange);
}

async function getTournamentRating(tournament) {
    let tournamentMatches = await getTournamentMatches(tournament);
    tournamentMatches = tournamentMatches.filter(x => x.rating !== null);
    if (tournamentMatches.length <= 0) {
        return 0
    }
    // Add main event weight (2x)
    if (tournamentMatches.length) {
        tournamentMatches.push(tournamentMatches[tournamentMatches.length - 1]);
    }
    const average = tournamentMatches.reduce((sum, match) => sum + match.rating, 0) / tournamentMatches.length;
    return myround(average, 0.25);
}

function checkFeudHot(feud, rating, superstars) {  // check_feud_hot
    let chance = 0;

    // No chance to get hot if already hot, not started or ended
    if (feud.hot || !feud.started || feud.ended || rating < 3.5) {
        return false;
    }

    // No chance if stale
    if (feud.stale) {
        return false;
    }

    // Minimum hype
    if (feud.hype < 30) {
        return false;
    }

    // Feud hype factor
    const increase = (feud.hype - 15) / 4;
    chance += increase;

    // Hot superstars factor
    let hotParticipantBonus = 0;
    for (const x of superstars) {
        if (x.hot) {
            hotParticipantBonus += 10 / superstars.length;
        } else if (x.stale) {
            hotParticipantBonus += -10 / superstars.length;
        }
    }
    chance += hotParticipantBonus;

    // Get trait multiplier for hot feud chance
    let traitBoost = 0;
    for (const superstar of superstars) {
        for (const trait of superstar.traits) {
            const traitData = traitsData[trait];
            if (traitData && traitData['hot_feud_chance_boost']) {
                traitBoost += traitData['hot_feud_chance_boost'];
            }
        }
    }
    traitBoost = limitValueBetweenRange(traitBoost, -20, 20);
    chance += traitBoost;

    // Max chance
    if (chance >= 50) {
        chance = 50;
    }

    if (getRandomInt(1, 100) <= chance) {
        feud.hot = true;
        return true;
    }

    return false;
}

function checkFeudItemsToUnlock(feudItem, feudItems) {  // check_feud_items_to_unlock
    // Check for feud item unlocks, returning unlocked
    const unlocked = [];
    const unlocksDict = {
        "New Challenger": "That's My Title",
        "Who's the Best?": "Innovation",
        "Taking My Spot": "It's My Time Now",
        "This Is Our Home": "Us vs Them",
        "Better Wrestler": "Greatest Wrestler",
        "Retire Me": "Streak vs Career",
        "Stepping Up": "Legend Killer",
        "Friendly Contest": "Redemption",
        "Better Villain": "Corruption",
        "Main Event Ready": "Best in the World",
        "Rivals": "Bitter Rivals",
    };
    const toUnlockName = unlocksDict[feudItem.name];
    if (toUnlockName) {
        const feudItemToUnlock = feudItems.find(x => x.name === toUnlockName);
        if (feudItemToUnlock && !feudItemToUnlock.unlocked && feudItem.level === 3) {
            feudItemToUnlock.unlocked = true;
            unlocked.push(feudItemToUnlock.name);
        }
    }
    return unlocked;
}

async function unlockSpecialSegment(company, segmentItemName, month, year, addMessage = true) {  // unlock_special_segment
    const segmentItem = (await getCompanySegmentItems(company)).find(x => x.name === segmentItemName);
    const user = loadUser();
    if (globalUser.paid && company.storyName !== 'mars') {
        if (segmentItem && !segmentItem.unlocked) {
            segmentItem.unlocked = true;

            // Add unlock message
            if (company.userControlled && addMessage) {
                const newMessage = await createSpecialSegmentUnlockedMessage(segmentItem, month, year);
                await addCompanyMessages(company, [newMessage]);
            }

            // Add unlocked segment to user
            if (!(user.unlockedSegments.includes(segmentItem.name))) {
                user.unlockedSegments.push(segmentItem.name);
                saveUser(user);
            }
        }
    }

    return true;
}

function getWorkrateXP(rating, order, trainerLevel) {  // get_workrate_xp
    const baseXPs = {1: 4, 2: 5.5, 3: 7};
    let baseXP = baseXPs[trainerLevel] || 7;

    if (order === 0) {
        baseXP += 2;
    }

    if (rating >= 4.5) {
        baseXP += 2;
    } else if (rating <= 2) { // Includes none rating
        baseXP -= 2;
    }

    return Math.floor(baseXP);
}

async function updateSuperstarWorkrate(superstar, company, staffMembers, month, year) { // update_superstar_workrate
    const xps = {2: 300, 1: 100};
    let levelIncrease = false;

    if (superstar.workrate < 3 && superstar.workrateXp >= (xps[superstar.workrate] || 300)) {
        superstar.workrate += 1;
        levelIncrease = true;

        // Add level up message
        if (company && company.userControlled) {
            const trainer = getRandomStaffMemberByRole(staffMembers, 'trainer');
            const newMessage = await createSuperstarLevelUpMessage(trainer, superstar, 'workrate', month, year);
            await addCompanyMessages(company, [newMessage]);
        }
    }

    return levelIncrease;
}

function checkCharacterToUnlock(character) {  // check_character_unlock
    let unlockedCharacters = [];
    const user = loadUser();
    if (user) {
        unlockedCharacters = user.unlockedCharacters;
    }

    const unlocksDict = {
        'Punk': 'Abstainer',
        'Rich Person': 'Degenerate',
        'Spot Monkey': 'Enigma',
        'Singer': 'Rapper',
        'Musician': 'Rockstar',
        'Occultist': 'Cult Leader',
        'Big Shot': 'Drug Lord',
        'VIP': 'Royalty',
        'Demon': 'Undead',
        'Philosophist': 'Game Dev.',
        'Game Dev.': 'Martian',
    };

    const toUnlock = unlocksDict[character];
    if (toUnlock) {
        const characterToUnlock = charactersData.find(x => x['name'] === toUnlock)?.name;
        if (characterToUnlock && !unlockedCharacters.includes(characterToUnlock)) {
            unlockedCharacters.push(characterToUnlock);
            saveUser(user);
            return characterToUnlock;
        }
    }

    return null;
}

function getGimmickEffectivenessChange(superstar, rating, order, weeklyShow, isWinner, boost = 1, match = false,
                                       hot = false, matchFinish = null) {
    // 1 boost is default for match, segments have custom boost
    let change = 0;

    if (rating !== null) {
        if (rating >= 4.25) {
            change += 2;
            if (order === 0) {
                change += 1;
            }
        } else if (rating < 2) {
            change -= 2;
            if (order === 0) {
                change -= 1;
            }
        }
    }

    // Add boost for match winner/loser
    if (match) {
        if (!matchFinish || matchFinish['affectRecord']) {
            if (isWinner) {
                change += boost;
            } else {
                change -= boost;
            }
        }
    } else {
        // Add boost for segment winner, if any
        if (isWinner) {
            if (rating >= 4) {
                change += boost;
            } else if (rating <= 2.5) {
                change -= boost;
            }
        }
    }

    // Add hot multiplier
    if (hot) {
        change *= 1.5;
    }

    // Reduce change for weekly show matches
    if (weeklyShow && match) {
        if (change > 1) {
            change *= 0.6;
        }
    }

    // Get trait multiplier for overness change
    for (const trait of superstar.traits) {
        const traitData = traitsData[trait];
        if (traitData && traitData['gimmick_effectiveness_increase_multiplier']) {
            if (change > 0) {
                change *= traitData['gimmick_effectiveness_increase_multiplier'];
            }
        }
        if (traitData && traitData['gimmick_effectiveness_decrease_multiplier']) {
            if (change < 0) {
                change *= traitData['gimmick_effectiveness_decrease_multiplier'];
            }
        }
    }

    change = limitValueBetweenRange(change, -10, 10);
    if (change > 10) {
        change = 10;
    }
    if (change < -10) {
        change = -10;
    }

    return Math.round(change);
}

function progressGimmick(gimmick, change, superstar) {  // progress_gimmick
    const oldOvernessEffect = getGimmickEffectivenessEffect(gimmick.effectiveness);
    gimmick.effectiveness += change;
    gimmick.effectiveness = limitValueBetweenRange(gimmick.effectiveness, 0, 100);

    const newOvernessEffect = getGimmickEffectivenessEffect(gimmick.effectiveness);

    // Add overness effect
    if (oldOvernessEffect !== newOvernessEffect) {
        superstar.overness -= oldOvernessEffect;
        superstar.overness += newOvernessEffect;
    }

    return {
        effectivenessChange: change,
        effectiveness: gimmick.effectiveness,
        name: gimmick.name,
        superstarName: superstar.name,
        overnessEffectChange: newOvernessEffect - oldOvernessEffect,
    };
}

function getStreakEndedBoosts(length) {  // get_streak_ended_boosts
    // No bonus
    if (length < 2) {
        return [1, 1];
    }
    // Bronze
    else if (length < 5) {
        return [1.4, 1.4];
    }
    // Silver
    else if (length < 10) {
        return [2.0, 2.0];
    }
    // Gold
    else if (length < 20) {
        return [3.4, 2.8];
    }
    // Obsidian
    else {
        return [6.0, 4.0];
    }
}

function getTournamentWinBonus(tournament) {  // get_tournament_win_bonus
    const bonuses = {'A': 2.3, 'B': 1.7, 'C': 1.3};
    let bonus = bonuses[tournament.prestige] || 1.2;
    if (tournament.annualTournament) {
        bonus = 4;
    }
    return bonus;
}

function getWinMultiplier(rank1, rank2) {  // get_win_multiplier
    const ranks = {'Main Eventer': 4, 'Upper Midcarder': 3, 'Lower Midcarder': 2, 'Jabroni': 1};
    if (ranks[rank1] <= ranks[rank2]) {
        return 1.5;
    } else {
        return -1;
    }
}

function getLossMultiplier(rank1, rank2) {  // get_loss_multiplier
    const ranks = {'Main Eventer': 4, 'Upper Midcarder': 3, 'Lower Midcarder': 2, 'Jabroni': 1};
    if (ranks[rank1] === ranks[rank2]) {
        return 1;
    } else if (ranks[rank1] >= ranks[rank2]) {
        return 1.25;
    } else {
        return -1;
    }
}

function getMatchPopularityIncrease(pop1, pop2, multiplier, gimmickMatchMultiplier = 1, activeEffectBoost = 1, streakEndedBoost = 1,
                                    tournamentWinIncrease = 1, popularityMultiplier = 1, matchHype = 0,
                                    weeklyShow = false, hotMatchIncrease = 1, hotSuperstarIncrease = 1,
                                    matchFinishWinMultiplier = 1) {  // get_match_popularity_increase
    const difference = Math.abs(pop1 - pop2);
    let increase;
    if (pop1 > pop2) {
        increase = 12 + getRandomInt(-2, 2);
    } else {
        if (difference <= 100) {
            increase = 14 + Math.floor(difference / 20) + getRandomInt(-2, 2);
        } else {
            if (multiplier === -1) {
                increase = 15 + getRandomInt(-1, 1);
            } else {
                increase = Math.floor(Math.floor(difference / 11) * multiplier);
            }
        }
    }
    increase = increase * gimmickMatchMultiplier * activeEffectBoost * streakEndedBoost * tournamentWinIncrease *
        popularityMultiplier * hotMatchIncrease * hotSuperstarIncrease * matchFinishWinMultiplier;
    increase += matchHype / 5.0;

    // Maximum increase
    if (increase > 80) {
        increase = 80;
    }
    if (weeklyShow) {
        if (hotMatchIncrease > 1) {
            increase *= 0.7;
        } else {
            increase *= 0.4;
        }
    }

    return Math.floor(increase);
}


function getMatchPopularityDecrease(pop1, pop2, multiplier, gimmickMatchMultiplier = 1, activeEffectBoost = 1, streakEndedBoost = 1,
                                    popularityMultiplier = 1, weeklyShow = false, hotMatchDecrease = 1,
                                    hotSuperstarDecrease = 1, matchFinishLossMultiplier = 1) {  // get_match_popularity_decrease
    const difference = Math.abs(pop1 - pop2);
    let decrease;
    if (pop2 > pop1 || matchFinishLossMultiplier < 0) {  // Don't add high decrease if time-limit draw finish
        decrease = 10 + getRandomInt(-2, 2);
    } else {
        if (difference <= 100) {
            decrease = 12 + Math.floor(difference / 20) + getRandomInt(-2, 2);
        } else {
            if (multiplier === -1) {
                decrease = 12 + getRandomInt(-1, 1);
            } else {
                decrease = Math.floor(Math.floor(difference / 11) * multiplier);
            }
        }
    }

    decrease = decrease * gimmickMatchMultiplier * activeEffectBoost * streakEndedBoost * popularityMultiplier * hotMatchDecrease *
        hotSuperstarDecrease * matchFinishLossMultiplier;

    // Ensure negative value
    if (matchFinishLossMultiplier < 0 && hotMatchDecrease < 0) {
        if (decrease > 0) {
            decrease *= -1;
        }
    }

    // Add hot match boost
    if (hotMatchDecrease < 0) {
        decrease -= getRandomInt(6, 10);
        if (pop2 > pop1 && difference > 50) {  // Higher boost for lower pop loser
            decrease -= getRandomInt(12, 16);
        }
    }

    // Maximum decrease
    if (decrease > 80) {
        decrease = 80;
    }
    if (weeklyShow) {
        if (hotMatchDecrease < 0) {
            decrease *= 0.7;
        } else {
            decrease *= 0.4;
        }
    }

    return Math.floor(decrease);
}

function getMatchOvernessIncrease(participant, popularityIncrease, fotc = false) {  // get_match_overness_increase
    let hot = participant.tempSuperstars.every(x => x.hot);
    let stale = participant.tempSuperstars.every(x => x.stale);

    let overnessIncrease;
    if (fotc) {
        if (hot) {
            overnessIncrease = Math.floor(popularityIncrease / 7.0);
        } else if (stale) {
            overnessIncrease = Math.floor(popularityIncrease / 3.0);
        } else {
            overnessIncrease = Math.floor(popularityIncrease / 5.0);
        }
    } else {
        // Popularity change will be high for hot superstar, since it increases, so use higher divisor here
        if (hot) {
            overnessIncrease = Math.floor(popularityIncrease / 15.0);
        } else if (stale) {
            overnessIncrease = Math.floor(popularityIncrease / 4.0);
        } else {
            overnessIncrease = Math.floor(popularityIncrease / 10.0);
        }
    }

    if (overnessIncrease > 10) {
        overnessIncrease = 10;
    }

    return overnessIncrease;
}

function getMatchOvernessDecrease(participant, popularityDecrease, fotc = false) {  // get_match_overness_decrease
    let hot = participant.tempSuperstars.every(x => x.hot);

    let overnessDecrease;
    if (fotc) {
        if (hot) {
            overnessDecrease = Math.floor(popularityDecrease / 2.0);
        } else {
            overnessDecrease = Math.floor(popularityDecrease / 4.0);
        }
    } else {
        if (hot) {
            overnessDecrease = Math.floor(popularityDecrease / 5.0);
        } else {
            overnessDecrease = Math.floor(popularityDecrease / 10.0);
        }
    }

    if (overnessDecrease > 8) {
        overnessDecrease = 8;
    }

    return overnessDecrease * -1;
}

async function getParticipantManagersData(participant, managersUsed, rosterSuperstars = null) {  // get_participant_managers_data
    // Gets managers data for match/segment participant to show in results
    const managersData = [];
    for (const s of (await getRosterMemberSuperstars(participant))) {
        const manager = await getSuperstarManagerUsedForMatchOrSegment(s, managersUsed, rosterSuperstars);
        if (manager) {
            const participantManagerData = {'name': manager.name, 'fullTimeManager': manager.fullTimeManager};
            if (!managersData.includes(participantManagerData)) {
                managersData.push(participantManagerData);
            }
        }
    }
    return managersData;
}

export {processPlayMatch, getParticipantManagersData, checkFeudHot, unlockSpecialSegment, getGimmickEffectivenessChange,
    progressGimmick, checkCharacterToUnlock, checkFeudItemsToUnlock, updateMatchOrSegmentGraphics, updateSuperstarWorkrate}